/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as PublicRouteImport } from './pages/_public'
import { Route as PrivateRouteImport } from './pages/_private'
import { Route as AuthRouteImport } from './pages/_auth'
import { Route as PublicIndexRouteImport } from './pages/_public/index'
import { Route as Public503RouteImport } from './pages/_public/503'
import { Route as Public403RouteImport } from './pages/_public/403'
import { Route as AuthLoginRouteImport } from './pages/_auth/login'
import { Route as PrivateDashboardLayoutRouteImport } from './pages/_private/dashboard/layout'
import { Route as PrivateDashboardTrucksRouteImport } from './pages/_private/dashboard/_trucks'
import { Route as PrivateDashboardSettingsRouteImport } from './pages/_private/dashboard/_settings'
import { Route as PrivateDashboardBaseRouteImport } from './pages/_private/dashboard/_base'
import { Route as PrivateDashboardBaseIndexRouteImport } from './pages/_private/dashboard/_base/index'
import { Route as PrivateDashboardTrucksCaminhoesLayoutRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/layout'
import { Route as PrivateDashboardSettingsConfiguracoesLayoutRouteImport } from './pages/_private/dashboard/_settings/configuracoes/layout'
import { Route as PrivateDashboardBaseUsuariosLayoutRouteImport } from './pages/_private/dashboard/_base/usuarios/layout'
import { Route as PrivateDashboardBaseProdutosLayoutRouteImport } from './pages/_private/dashboard/_base/produtos/layout'
import { Route as PrivateDashboardBaseMotoristasLayoutRouteImport } from './pages/_private/dashboard/_base/motoristas/layout'
import { Route as PrivateDashboardBaseLogsLayoutRouteImport } from './pages/_private/dashboard/_base/logs/layout'
import { Route as PrivateDashboardBaseConjuntosLayoutRouteImport } from './pages/_private/dashboard/_base/conjuntos/layout'
import { Route as PrivateDashboardTrucksCaminhoesIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/index'
import { Route as PrivateDashboardSettingsConfiguracoesIndexRouteImport } from './pages/_private/dashboard/_settings/configuracoes/index'
import { Route as PrivateDashboardBaseUsuariosIndexRouteImport } from './pages/_private/dashboard/_base/usuarios/index'
import { Route as PrivateDashboardBaseTransportadorasIndexRouteImport } from './pages/_private/dashboard/_base/transportadoras/index'
import { Route as PrivateDashboardBaseResgateIndexRouteImport } from './pages/_private/dashboard/_base/resgate/index'
import { Route as PrivateDashboardBaseProdutosIndexRouteImport } from './pages/_private/dashboard/_base/produtos/index'
import { Route as PrivateDashboardBasePerfilIndexRouteImport } from './pages/_private/dashboard/_base/perfil/index'
import { Route as PrivateDashboardBasePedidosIndexRouteImport } from './pages/_private/dashboard/_base/pedidos/index'
import { Route as PrivateDashboardBaseMotoristasIndexRouteImport } from './pages/_private/dashboard/_base/motoristas/index'
import { Route as PrivateDashboardBaseLogsIndexRouteImport } from './pages/_private/dashboard/_base/logs/index'
import { Route as PrivateDashboardBaseFilaIndexRouteImport } from './pages/_private/dashboard/_base/fila/index'
import { Route as PrivateDashboardBaseEmpresasIndexRouteImport } from './pages/_private/dashboard/_base/empresas/index'
import { Route as PrivateDashboardBaseConjuntosIndexRouteImport } from './pages/_private/dashboard/_base/conjuntos/index'
import { Route as PrivateDashboardBaseClientesIndexRouteImport } from './pages/_private/dashboard/_base/clientes/index'
import { Route as PrivateDashboardSettingsConfiguracoesInformacoesRouteImport } from './pages/_private/dashboard/_settings/configuracoes/informacoes'
import { Route as PrivateDashboardSettingsConfiguracoesBloqueiosRouteImport } from './pages/_private/dashboard/_settings/configuracoes/bloqueios'
import { Route as PrivateDashboardSettingsConfiguracoesAvisosRouteImport } from './pages/_private/dashboard/_settings/configuracoes/avisos'
import { Route as PrivateDashboardBaseTransportadorasFormsRouteImport } from './pages/_private/dashboard/_base/transportadoras/_forms'
import { Route as PrivateDashboardBasePerfilModalRouteImport } from './pages/_private/dashboard/_base/perfil/modal'
import { Route as PrivateDashboardBasePedidosCadastrarLayoutRouteImport } from './pages/_private/dashboard/_base/pedidos/cadastrar/layout'
import { Route as PrivateDashboardBasePedidosIdLayoutRouteImport } from './pages/_private/dashboard/_base/pedidos/$id/layout'
import { Route as PrivateDashboardBaseLogsIdLayoutRouteImport } from './pages/_private/dashboard/_base/logs/$id/layout'
import { Route as PrivateDashboardTrucksCaminhoesModelosIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/modelos/index'
import { Route as PrivateDashboardTrucksCaminhoesMarcasIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/marcas/index'
import { Route as PrivateDashboardTrucksCaminhoesImplementosIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/implementos/index'
import { Route as PrivateDashboardTrucksCaminhoesEditarIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/editar/index'
import { Route as PrivateDashboardTrucksCaminhoesCarregamentosIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/carregamentos/index'
import { Route as PrivateDashboardTrucksCaminhoesCadastrarIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/cadastrar/index'
import { Route as PrivateDashboardSettingsConfiguracoesTermosIndexRouteImport } from './pages/_private/dashboard/_settings/configuracoes/termos/index'
import { Route as PrivateDashboardSettingsConfiguracoesPopupsIndexRouteImport } from './pages/_private/dashboard/_settings/configuracoes/popups/index'
import { Route as PrivateDashboardBaseUsuariosEditarIndexRouteImport } from './pages/_private/dashboard/_base/usuarios/editar/index'
import { Route as PrivateDashboardBaseUsuariosCadastrarIndexRouteImport } from './pages/_private/dashboard/_base/usuarios/cadastrar/index'
import { Route as PrivateDashboardBaseProdutosEditarIndexRouteImport } from './pages/_private/dashboard/_base/produtos/editar/index'
import { Route as PrivateDashboardBasePedidosEditarIndexRouteImport } from './pages/_private/dashboard/_base/pedidos/editar/index'
import { Route as PrivateDashboardBasePedidosCadastrarIndexRouteImport } from './pages/_private/dashboard/_base/pedidos/cadastrar/index'
import { Route as PrivateDashboardBasePedidosIdIndexRouteImport } from './pages/_private/dashboard/_base/pedidos/$id/index'
import { Route as PrivateDashboardBaseMotoristasEditarIndexRouteImport } from './pages/_private/dashboard/_base/motoristas/editar/index'
import { Route as PrivateDashboardBaseMotoristasCadastrarIndexRouteImport } from './pages/_private/dashboard/_base/motoristas/cadastrar/index'
import { Route as PrivateDashboardBaseLogsIdIndexRouteImport } from './pages/_private/dashboard/_base/logs/$id/index'
import { Route as PrivateDashboardBaseEmpresasEditarIndexRouteImport } from './pages/_private/dashboard/_base/empresas/editar/index'
import { Route as PrivateDashboardBaseEmpresasCadastrarIndexRouteImport } from './pages/_private/dashboard/_base/empresas/cadastrar/index'
import { Route as PrivateDashboardBaseConjuntosVincularIndexRouteImport } from './pages/_private/dashboard/_base/conjuntos/vincular/index'
import { Route as PrivateDashboardBaseClientesEditarIndexRouteImport } from './pages/_private/dashboard/_base/clientes/editar/index'
import { Route as PrivateDashboardBaseClientesCadastrarIndexRouteImport } from './pages/_private/dashboard/_base/clientes/cadastrar/index'
import { Route as PrivateDashboardTrucksCaminhoesCadastrarModalRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/cadastrar/modal'
import { Route as PrivateDashboardBaseUsuariosCadastrarModalRouteImport } from './pages/_private/dashboard/_base/usuarios/cadastrar/modal'
import { Route as PrivateDashboardBasePedidosCadastrarModalRouteImport } from './pages/_private/dashboard/_base/pedidos/cadastrar/modal'
import { Route as PrivateDashboardBasePedidosIdModalRouteImport } from './pages/_private/dashboard/_base/pedidos/$id/modal'
import { Route as PrivateDashboardBaseMotoristasCadastrarModalRouteImport } from './pages/_private/dashboard/_base/motoristas/cadastrar/modal'
import { Route as PrivateDashboardBaseLogsIdModalRouteImport } from './pages/_private/dashboard/_base/logs/$id/modal'
import { Route as PrivateDashboardBaseEmpresasCadastrarModalRouteImport } from './pages/_private/dashboard/_base/empresas/cadastrar/modal'
import { Route as PrivateDashboardBaseConjuntosVincularTransportadoraRouteImport } from './pages/_private/dashboard/_base/conjuntos/vincular/transportadora'
import { Route as PrivateDashboardBaseClientesCadastrarModalRouteImport } from './pages/_private/dashboard/_base/clientes/cadastrar/modal'
import { Route as PrivateAprovarTermoTransportadoraEmpresaCompanyIdUserIdRouteImport } from './pages/_private/aprovar-termo.transportadora.empresa.$companyId.$userId'
import { Route as PrivateDashboardTrucksCaminhoesEditarIdLayoutRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/editar/$id/layout'
import { Route as PrivateDashboardSettingsConfiguracoesTermosIdLayoutRouteImport } from './pages/_private/dashboard/_settings/configuracoes/termos/$id/layout'
import { Route as PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRouteImport } from './pages/_private/dashboard/_settings/configuracoes/popups/$id/layout'
import { Route as PrivateDashboardBaseUsuariosEditarIdLayoutRouteImport } from './pages/_private/dashboard/_base/usuarios/editar/$id/layout'
import { Route as PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRouteImport } from './pages/_private/dashboard/_base/transportadoras/_forms/cadastrar/layout'
import { Route as PrivateDashboardBaseProdutosEditarIdLayoutRouteImport } from './pages/_private/dashboard/_base/produtos/editar/$id/layout'
import { Route as PrivateDashboardBasePedidosEditarIdLayoutRouteImport } from './pages/_private/dashboard/_base/pedidos/editar/$id/layout'
import { Route as PrivateDashboardBaseMotoristasEditarIdLayoutRouteImport } from './pages/_private/dashboard/_base/motoristas/editar/$id/layout'
import { Route as PrivateDashboardBaseEmpresasEditarIdLayoutRouteImport } from './pages/_private/dashboard/_base/empresas/editar/$id/layout'
import { Route as PrivateDashboardBaseClientesEditarIdLayoutRouteImport } from './pages/_private/dashboard/_base/clientes/editar/$id/layout'
import { Route as PrivateDashboardTrucksCaminhoesModelosEditarIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/modelos/editar/index'
import { Route as PrivateDashboardTrucksCaminhoesModelosCadastrarIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/modelos/cadastrar/index'
import { Route as PrivateDashboardTrucksCaminhoesMarcasEditarIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/marcas/editar/index'
import { Route as PrivateDashboardTrucksCaminhoesMarcasCadastrarIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/marcas/cadastrar/index'
import { Route as PrivateDashboardTrucksCaminhoesImplementosEditarIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/implementos/editar/index'
import { Route as PrivateDashboardTrucksCaminhoesImplementosCadastrarIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/implementos/cadastrar/index'
import { Route as PrivateDashboardTrucksCaminhoesEditarIdIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/editar/$id/index'
import { Route as PrivateDashboardTrucksCaminhoesCarregamentosEditarIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/carregamentos/editar/index'
import { Route as PrivateDashboardTrucksCaminhoesCarregamentosCadastrarIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/carregamentos/cadastrar/index'
import { Route as PrivateDashboardSettingsConfiguracoesTermosIdIndexRouteImport } from './pages/_private/dashboard/_settings/configuracoes/termos/$id/index'
import { Route as PrivateDashboardSettingsConfiguracoesPopupsIdIndexRouteImport } from './pages/_private/dashboard/_settings/configuracoes/popups/$id/index'
import { Route as PrivateDashboardBaseUsuariosEditarIdIndexRouteImport } from './pages/_private/dashboard/_base/usuarios/editar/$id/index'
import { Route as PrivateDashboardBaseTransportadorasFormsEditarIndexRouteImport } from './pages/_private/dashboard/_base/transportadoras/_forms/editar/index'
import { Route as PrivateDashboardBaseTransportadorasFormsCadastrarIndexRouteImport } from './pages/_private/dashboard/_base/transportadoras/_forms/cadastrar/index'
import { Route as PrivateDashboardBaseProdutosEditarIdIndexRouteImport } from './pages/_private/dashboard/_base/produtos/editar/$id/index'
import { Route as PrivateDashboardBasePedidosEditarIdIndexRouteImport } from './pages/_private/dashboard/_base/pedidos/editar/$id/index'
import { Route as PrivateDashboardBaseMotoristasEditarIdIndexRouteImport } from './pages/_private/dashboard/_base/motoristas/editar/$id/index'
import { Route as PrivateDashboardBaseEmpresasEditarIdIndexRouteImport } from './pages/_private/dashboard/_base/empresas/editar/$id/index'
import { Route as PrivateDashboardBaseClientesEditarIdIndexRouteImport } from './pages/_private/dashboard/_base/clientes/editar/$id/index'
import { Route as PrivateDashboardTrucksCaminhoesModelosCadastrarModalRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/modelos/cadastrar/modal'
import { Route as PrivateDashboardTrucksCaminhoesMarcasCadastrarModalRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/marcas/cadastrar/modal'
import { Route as PrivateDashboardTrucksCaminhoesImplementosCadastrarModalRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/implementos/cadastrar/modal'
import { Route as PrivateDashboardTrucksCaminhoesEditarIdModalRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/editar/$id/modal'
import { Route as PrivateDashboardTrucksCaminhoesCarregamentosCadastrarModalRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/carregamentos/cadastrar/modal'
import { Route as PrivateDashboardSettingsConfiguracoesTermosIdModalRouteImport } from './pages/_private/dashboard/_settings/configuracoes/termos/$id/modal'
import { Route as PrivateDashboardSettingsConfiguracoesPopupsIdModalRouteImport } from './pages/_private/dashboard/_settings/configuracoes/popups/$id/modal'
import { Route as PrivateDashboardBaseUsuariosEditarIdModalRouteImport } from './pages/_private/dashboard/_base/usuarios/editar/$id/modal'
import { Route as PrivateDashboardBaseTransportadorasFormsCadastrarModalRouteImport } from './pages/_private/dashboard/_base/transportadoras/_forms/cadastrar/modal'
import { Route as PrivateDashboardBaseProdutosEditarIdModalRouteImport } from './pages/_private/dashboard/_base/produtos/editar/$id/modal'
import { Route as PrivateDashboardBasePedidosEditarIdModalRouteImport } from './pages/_private/dashboard/_base/pedidos/editar/$id/modal'
import { Route as PrivateDashboardBaseMotoristasEditarIdModalRouteImport } from './pages/_private/dashboard/_base/motoristas/editar/$id/modal'
import { Route as PrivateDashboardBaseEmpresasEditarIdModalRouteImport } from './pages/_private/dashboard/_base/empresas/editar/$id/modal'
import { Route as PrivateDashboardBaseClientesEditarIdModalRouteImport } from './pages/_private/dashboard/_base/clientes/editar/$id/modal'
import { Route as PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/modelos/editar/$id/layout'
import { Route as PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/marcas/editar/$id/layout'
import { Route as PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/implementos/editar/$id/layout'
import { Route as PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id/layout'
import { Route as PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRouteImport } from './pages/_private/dashboard/_base/transportadoras/_forms/editar/$id/layout'
import { Route as PrivateDashboardTrucksCaminhoesModelosEditarIdIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/modelos/editar/$id/index'
import { Route as PrivateDashboardTrucksCaminhoesMarcasEditarIdIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/marcas/editar/$id/index'
import { Route as PrivateDashboardTrucksCaminhoesImplementosEditarIdIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/implementos/editar/$id/index'
import { Route as PrivateDashboardTrucksCaminhoesCarregamentosEditarIdIndexRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id/index'
import { Route as PrivateDashboardBaseTransportadorasFormsEditarIdIndexRouteImport } from './pages/_private/dashboard/_base/transportadoras/_forms/editar/$id/index'
import { Route as PrivateDashboardTrucksCaminhoesModelosEditarIdModalRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/modelos/editar/$id/modal'
import { Route as PrivateDashboardTrucksCaminhoesMarcasEditarIdModalRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/marcas/editar/$id/modal'
import { Route as PrivateDashboardTrucksCaminhoesImplementosEditarIdModalRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/implementos/editar/$id/modal'
import { Route as PrivateDashboardTrucksCaminhoesCarregamentosEditarIdModalRouteImport } from './pages/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id/modal'
import { Route as PrivateDashboardBaseTransportadorasFormsEditarIdModalRouteImport } from './pages/_private/dashboard/_base/transportadoras/_forms/editar/$id/modal'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateRoute = PrivateRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const Public503Route = Public503RouteImport.update({
  id: '/503',
  path: '/503',
  getParentRoute: () => PublicRoute,
} as any)
const Public403Route = Public403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => PublicRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const PrivateDashboardLayoutRoute = PrivateDashboardLayoutRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateDashboardTrucksRoute = PrivateDashboardTrucksRouteImport.update({
  id: '/_trucks',
  getParentRoute: () => PrivateDashboardLayoutRoute,
} as any)
const PrivateDashboardSettingsRoute =
  PrivateDashboardSettingsRouteImport.update({
    id: '/_settings',
    getParentRoute: () => PrivateDashboardLayoutRoute,
  } as any)
const PrivateDashboardBaseRoute = PrivateDashboardBaseRouteImport.update({
  id: '/_base',
  getParentRoute: () => PrivateDashboardLayoutRoute,
} as any)
const PrivateDashboardBaseIndexRoute =
  PrivateDashboardBaseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesLayoutRoute =
  PrivateDashboardTrucksCaminhoesLayoutRouteImport.update({
    id: '/caminhoes',
    path: '/caminhoes',
    getParentRoute: () => PrivateDashboardTrucksRoute,
  } as any)
const PrivateDashboardSettingsConfiguracoesLayoutRoute =
  PrivateDashboardSettingsConfiguracoesLayoutRouteImport.update({
    id: '/configuracoes',
    path: '/configuracoes',
    getParentRoute: () => PrivateDashboardSettingsRoute,
  } as any)
const PrivateDashboardBaseUsuariosLayoutRoute =
  PrivateDashboardBaseUsuariosLayoutRouteImport.update({
    id: '/usuarios',
    path: '/usuarios',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseProdutosLayoutRoute =
  PrivateDashboardBaseProdutosLayoutRouteImport.update({
    id: '/produtos',
    path: '/produtos',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseMotoristasLayoutRoute =
  PrivateDashboardBaseMotoristasLayoutRouteImport.update({
    id: '/motoristas',
    path: '/motoristas',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseLogsLayoutRoute =
  PrivateDashboardBaseLogsLayoutRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseConjuntosLayoutRoute =
  PrivateDashboardBaseConjuntosLayoutRouteImport.update({
    id: '/conjuntos',
    path: '/conjuntos',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesIndexRoute =
  PrivateDashboardTrucksCaminhoesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardSettingsConfiguracoesIndexRoute =
  PrivateDashboardSettingsConfiguracoesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardSettingsConfiguracoesLayoutRoute,
  } as any)
const PrivateDashboardBaseUsuariosIndexRoute =
  PrivateDashboardBaseUsuariosIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBaseUsuariosLayoutRoute,
  } as any)
const PrivateDashboardBaseTransportadorasIndexRoute =
  PrivateDashboardBaseTransportadorasIndexRouteImport.update({
    id: '/transportadoras/',
    path: '/transportadoras/',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseResgateIndexRoute =
  PrivateDashboardBaseResgateIndexRouteImport.update({
    id: '/resgate/',
    path: '/resgate/',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseProdutosIndexRoute =
  PrivateDashboardBaseProdutosIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBaseProdutosLayoutRoute,
  } as any)
const PrivateDashboardBasePerfilIndexRoute =
  PrivateDashboardBasePerfilIndexRouteImport.update({
    id: '/perfil/',
    path: '/perfil/',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBasePedidosIndexRoute =
  PrivateDashboardBasePedidosIndexRouteImport.update({
    id: '/pedidos/',
    path: '/pedidos/',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseMotoristasIndexRoute =
  PrivateDashboardBaseMotoristasIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBaseMotoristasLayoutRoute,
  } as any)
const PrivateDashboardBaseLogsIndexRoute =
  PrivateDashboardBaseLogsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBaseLogsLayoutRoute,
  } as any)
const PrivateDashboardBaseFilaIndexRoute =
  PrivateDashboardBaseFilaIndexRouteImport.update({
    id: '/fila/',
    path: '/fila/',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseEmpresasIndexRoute =
  PrivateDashboardBaseEmpresasIndexRouteImport.update({
    id: '/empresas/',
    path: '/empresas/',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseConjuntosIndexRoute =
  PrivateDashboardBaseConjuntosIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBaseConjuntosLayoutRoute,
  } as any)
const PrivateDashboardBaseClientesIndexRoute =
  PrivateDashboardBaseClientesIndexRouteImport.update({
    id: '/clientes/',
    path: '/clientes/',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardSettingsConfiguracoesInformacoesRoute =
  PrivateDashboardSettingsConfiguracoesInformacoesRouteImport.update({
    id: '/informacoes',
    path: '/informacoes',
    getParentRoute: () => PrivateDashboardSettingsConfiguracoesLayoutRoute,
  } as any)
const PrivateDashboardSettingsConfiguracoesBloqueiosRoute =
  PrivateDashboardSettingsConfiguracoesBloqueiosRouteImport.update({
    id: '/bloqueios',
    path: '/bloqueios',
    getParentRoute: () => PrivateDashboardSettingsConfiguracoesLayoutRoute,
  } as any)
const PrivateDashboardSettingsConfiguracoesAvisosRoute =
  PrivateDashboardSettingsConfiguracoesAvisosRouteImport.update({
    id: '/avisos',
    path: '/avisos',
    getParentRoute: () => PrivateDashboardSettingsConfiguracoesLayoutRoute,
  } as any)
const PrivateDashboardBaseTransportadorasFormsRoute =
  PrivateDashboardBaseTransportadorasFormsRouteImport.update({
    id: '/transportadoras/_forms',
    path: '/transportadoras',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBasePerfilModalRoute =
  PrivateDashboardBasePerfilModalRouteImport.update({
    id: '/perfil/modal',
    path: '/perfil/modal',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBasePedidosCadastrarLayoutRoute =
  PrivateDashboardBasePedidosCadastrarLayoutRouteImport.update({
    id: '/pedidos/cadastrar',
    path: '/pedidos/cadastrar',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBasePedidosIdLayoutRoute =
  PrivateDashboardBasePedidosIdLayoutRouteImport.update({
    id: '/pedidos/$id',
    path: '/pedidos/$id',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseLogsIdLayoutRoute =
  PrivateDashboardBaseLogsIdLayoutRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => PrivateDashboardBaseLogsLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesModelosIndexRoute =
  PrivateDashboardTrucksCaminhoesModelosIndexRouteImport.update({
    id: '/modelos/',
    path: '/modelos/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesMarcasIndexRoute =
  PrivateDashboardTrucksCaminhoesMarcasIndexRouteImport.update({
    id: '/marcas/',
    path: '/marcas/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesImplementosIndexRoute =
  PrivateDashboardTrucksCaminhoesImplementosIndexRouteImport.update({
    id: '/implementos/',
    path: '/implementos/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesEditarIndexRoute =
  PrivateDashboardTrucksCaminhoesEditarIndexRouteImport.update({
    id: '/editar/',
    path: '/editar/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesCarregamentosIndexRoute =
  PrivateDashboardTrucksCaminhoesCarregamentosIndexRouteImport.update({
    id: '/carregamentos/',
    path: '/carregamentos/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesCadastrarIndexRoute =
  PrivateDashboardTrucksCaminhoesCadastrarIndexRouteImport.update({
    id: '/cadastrar/',
    path: '/cadastrar/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardSettingsConfiguracoesTermosIndexRoute =
  PrivateDashboardSettingsConfiguracoesTermosIndexRouteImport.update({
    id: '/termos/',
    path: '/termos/',
    getParentRoute: () => PrivateDashboardSettingsConfiguracoesLayoutRoute,
  } as any)
const PrivateDashboardSettingsConfiguracoesPopupsIndexRoute =
  PrivateDashboardSettingsConfiguracoesPopupsIndexRouteImport.update({
    id: '/popups/',
    path: '/popups/',
    getParentRoute: () => PrivateDashboardSettingsConfiguracoesLayoutRoute,
  } as any)
const PrivateDashboardBaseUsuariosEditarIndexRoute =
  PrivateDashboardBaseUsuariosEditarIndexRouteImport.update({
    id: '/editar/',
    path: '/editar/',
    getParentRoute: () => PrivateDashboardBaseUsuariosLayoutRoute,
  } as any)
const PrivateDashboardBaseUsuariosCadastrarIndexRoute =
  PrivateDashboardBaseUsuariosCadastrarIndexRouteImport.update({
    id: '/cadastrar/',
    path: '/cadastrar/',
    getParentRoute: () => PrivateDashboardBaseUsuariosLayoutRoute,
  } as any)
const PrivateDashboardBaseProdutosEditarIndexRoute =
  PrivateDashboardBaseProdutosEditarIndexRouteImport.update({
    id: '/editar/',
    path: '/editar/',
    getParentRoute: () => PrivateDashboardBaseProdutosLayoutRoute,
  } as any)
const PrivateDashboardBasePedidosEditarIndexRoute =
  PrivateDashboardBasePedidosEditarIndexRouteImport.update({
    id: '/pedidos/editar/',
    path: '/pedidos/editar/',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBasePedidosCadastrarIndexRoute =
  PrivateDashboardBasePedidosCadastrarIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBasePedidosCadastrarLayoutRoute,
  } as any)
const PrivateDashboardBasePedidosIdIndexRoute =
  PrivateDashboardBasePedidosIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBasePedidosIdLayoutRoute,
  } as any)
const PrivateDashboardBaseMotoristasEditarIndexRoute =
  PrivateDashboardBaseMotoristasEditarIndexRouteImport.update({
    id: '/editar/',
    path: '/editar/',
    getParentRoute: () => PrivateDashboardBaseMotoristasLayoutRoute,
  } as any)
const PrivateDashboardBaseMotoristasCadastrarIndexRoute =
  PrivateDashboardBaseMotoristasCadastrarIndexRouteImport.update({
    id: '/cadastrar/',
    path: '/cadastrar/',
    getParentRoute: () => PrivateDashboardBaseMotoristasLayoutRoute,
  } as any)
const PrivateDashboardBaseLogsIdIndexRoute =
  PrivateDashboardBaseLogsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBaseLogsIdLayoutRoute,
  } as any)
const PrivateDashboardBaseEmpresasEditarIndexRoute =
  PrivateDashboardBaseEmpresasEditarIndexRouteImport.update({
    id: '/empresas/editar/',
    path: '/empresas/editar/',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseEmpresasCadastrarIndexRoute =
  PrivateDashboardBaseEmpresasCadastrarIndexRouteImport.update({
    id: '/empresas/cadastrar/',
    path: '/empresas/cadastrar/',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseConjuntosVincularIndexRoute =
  PrivateDashboardBaseConjuntosVincularIndexRouteImport.update({
    id: '/vincular/',
    path: '/vincular/',
    getParentRoute: () => PrivateDashboardBaseConjuntosLayoutRoute,
  } as any)
const PrivateDashboardBaseClientesEditarIndexRoute =
  PrivateDashboardBaseClientesEditarIndexRouteImport.update({
    id: '/clientes/editar/',
    path: '/clientes/editar/',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseClientesCadastrarIndexRoute =
  PrivateDashboardBaseClientesCadastrarIndexRouteImport.update({
    id: '/clientes/cadastrar/',
    path: '/clientes/cadastrar/',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesCadastrarModalRoute =
  PrivateDashboardTrucksCaminhoesCadastrarModalRouteImport.update({
    id: '/cadastrar/modal',
    path: '/cadastrar/modal',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardBaseUsuariosCadastrarModalRoute =
  PrivateDashboardBaseUsuariosCadastrarModalRouteImport.update({
    id: '/cadastrar/modal',
    path: '/cadastrar/modal',
    getParentRoute: () => PrivateDashboardBaseUsuariosLayoutRoute,
  } as any)
const PrivateDashboardBasePedidosCadastrarModalRoute =
  PrivateDashboardBasePedidosCadastrarModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () => PrivateDashboardBasePedidosCadastrarLayoutRoute,
  } as any)
const PrivateDashboardBasePedidosIdModalRoute =
  PrivateDashboardBasePedidosIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () => PrivateDashboardBasePedidosIdLayoutRoute,
  } as any)
const PrivateDashboardBaseMotoristasCadastrarModalRoute =
  PrivateDashboardBaseMotoristasCadastrarModalRouteImport.update({
    id: '/cadastrar/modal',
    path: '/cadastrar/modal',
    getParentRoute: () => PrivateDashboardBaseMotoristasLayoutRoute,
  } as any)
const PrivateDashboardBaseLogsIdModalRoute =
  PrivateDashboardBaseLogsIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () => PrivateDashboardBaseLogsIdLayoutRoute,
  } as any)
const PrivateDashboardBaseEmpresasCadastrarModalRoute =
  PrivateDashboardBaseEmpresasCadastrarModalRouteImport.update({
    id: '/empresas/cadastrar/modal',
    path: '/empresas/cadastrar/modal',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseConjuntosVincularTransportadoraRoute =
  PrivateDashboardBaseConjuntosVincularTransportadoraRouteImport.update({
    id: '/vincular/transportadora',
    path: '/vincular/transportadora',
    getParentRoute: () => PrivateDashboardBaseConjuntosLayoutRoute,
  } as any)
const PrivateDashboardBaseClientesCadastrarModalRoute =
  PrivateDashboardBaseClientesCadastrarModalRouteImport.update({
    id: '/clientes/cadastrar/modal',
    path: '/clientes/cadastrar/modal',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateAprovarTermoTransportadoraEmpresaCompanyIdUserIdRoute =
  PrivateAprovarTermoTransportadoraEmpresaCompanyIdUserIdRouteImport.update({
    id: '/aprovar-termo/transportadora/empresa/$companyId/$userId',
    path: '/aprovar-termo/transportadora/empresa/$companyId/$userId',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesEditarIdLayoutRoute =
  PrivateDashboardTrucksCaminhoesEditarIdLayoutRouteImport.update({
    id: '/editar/$id',
    path: '/editar/$id',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardSettingsConfiguracoesTermosIdLayoutRoute =
  PrivateDashboardSettingsConfiguracoesTermosIdLayoutRouteImport.update({
    id: '/termos/$id',
    path: '/termos/$id',
    getParentRoute: () => PrivateDashboardSettingsConfiguracoesLayoutRoute,
  } as any)
const PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRoute =
  PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRouteImport.update({
    id: '/popups/$id',
    path: '/popups/$id',
    getParentRoute: () => PrivateDashboardSettingsConfiguracoesLayoutRoute,
  } as any)
const PrivateDashboardBaseUsuariosEditarIdLayoutRoute =
  PrivateDashboardBaseUsuariosEditarIdLayoutRouteImport.update({
    id: '/editar/$id',
    path: '/editar/$id',
    getParentRoute: () => PrivateDashboardBaseUsuariosLayoutRoute,
  } as any)
const PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRoute =
  PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRouteImport.update({
    id: '/cadastrar',
    path: '/cadastrar',
    getParentRoute: () => PrivateDashboardBaseTransportadorasFormsRoute,
  } as any)
const PrivateDashboardBaseProdutosEditarIdLayoutRoute =
  PrivateDashboardBaseProdutosEditarIdLayoutRouteImport.update({
    id: '/editar/$id',
    path: '/editar/$id',
    getParentRoute: () => PrivateDashboardBaseProdutosLayoutRoute,
  } as any)
const PrivateDashboardBasePedidosEditarIdLayoutRoute =
  PrivateDashboardBasePedidosEditarIdLayoutRouteImport.update({
    id: '/pedidos/editar/$id',
    path: '/pedidos/editar/$id',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseMotoristasEditarIdLayoutRoute =
  PrivateDashboardBaseMotoristasEditarIdLayoutRouteImport.update({
    id: '/editar/$id',
    path: '/editar/$id',
    getParentRoute: () => PrivateDashboardBaseMotoristasLayoutRoute,
  } as any)
const PrivateDashboardBaseEmpresasEditarIdLayoutRoute =
  PrivateDashboardBaseEmpresasEditarIdLayoutRouteImport.update({
    id: '/empresas/editar/$id',
    path: '/empresas/editar/$id',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardBaseClientesEditarIdLayoutRoute =
  PrivateDashboardBaseClientesEditarIdLayoutRouteImport.update({
    id: '/clientes/editar/$id',
    path: '/clientes/editar/$id',
    getParentRoute: () => PrivateDashboardBaseRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesModelosEditarIndexRoute =
  PrivateDashboardTrucksCaminhoesModelosEditarIndexRouteImport.update({
    id: '/modelos/editar/',
    path: '/modelos/editar/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesModelosCadastrarIndexRoute =
  PrivateDashboardTrucksCaminhoesModelosCadastrarIndexRouteImport.update({
    id: '/modelos/cadastrar/',
    path: '/modelos/cadastrar/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesMarcasEditarIndexRoute =
  PrivateDashboardTrucksCaminhoesMarcasEditarIndexRouteImport.update({
    id: '/marcas/editar/',
    path: '/marcas/editar/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesMarcasCadastrarIndexRoute =
  PrivateDashboardTrucksCaminhoesMarcasCadastrarIndexRouteImport.update({
    id: '/marcas/cadastrar/',
    path: '/marcas/cadastrar/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesImplementosEditarIndexRoute =
  PrivateDashboardTrucksCaminhoesImplementosEditarIndexRouteImport.update({
    id: '/implementos/editar/',
    path: '/implementos/editar/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesImplementosCadastrarIndexRoute =
  PrivateDashboardTrucksCaminhoesImplementosCadastrarIndexRouteImport.update({
    id: '/implementos/cadastrar/',
    path: '/implementos/cadastrar/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesEditarIdIndexRoute =
  PrivateDashboardTrucksCaminhoesEditarIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesEditarIdLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesCarregamentosEditarIndexRoute =
  PrivateDashboardTrucksCaminhoesCarregamentosEditarIndexRouteImport.update({
    id: '/carregamentos/editar/',
    path: '/carregamentos/editar/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesCarregamentosCadastrarIndexRoute =
  PrivateDashboardTrucksCaminhoesCarregamentosCadastrarIndexRouteImport.update({
    id: '/carregamentos/cadastrar/',
    path: '/carregamentos/cadastrar/',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardSettingsConfiguracoesTermosIdIndexRoute =
  PrivateDashboardSettingsConfiguracoesTermosIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      PrivateDashboardSettingsConfiguracoesTermosIdLayoutRoute,
  } as any)
const PrivateDashboardSettingsConfiguracoesPopupsIdIndexRoute =
  PrivateDashboardSettingsConfiguracoesPopupsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRoute,
  } as any)
const PrivateDashboardBaseUsuariosEditarIdIndexRoute =
  PrivateDashboardBaseUsuariosEditarIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBaseUsuariosEditarIdLayoutRoute,
  } as any)
const PrivateDashboardBaseTransportadorasFormsEditarIndexRoute =
  PrivateDashboardBaseTransportadorasFormsEditarIndexRouteImport.update({
    id: '/editar/',
    path: '/editar/',
    getParentRoute: () => PrivateDashboardBaseTransportadorasFormsRoute,
  } as any)
const PrivateDashboardBaseTransportadorasFormsCadastrarIndexRoute =
  PrivateDashboardBaseTransportadorasFormsCadastrarIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRoute,
  } as any)
const PrivateDashboardBaseProdutosEditarIdIndexRoute =
  PrivateDashboardBaseProdutosEditarIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBaseProdutosEditarIdLayoutRoute,
  } as any)
const PrivateDashboardBasePedidosEditarIdIndexRoute =
  PrivateDashboardBasePedidosEditarIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBasePedidosEditarIdLayoutRoute,
  } as any)
const PrivateDashboardBaseMotoristasEditarIdIndexRoute =
  PrivateDashboardBaseMotoristasEditarIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBaseMotoristasEditarIdLayoutRoute,
  } as any)
const PrivateDashboardBaseEmpresasEditarIdIndexRoute =
  PrivateDashboardBaseEmpresasEditarIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBaseEmpresasEditarIdLayoutRoute,
  } as any)
const PrivateDashboardBaseClientesEditarIdIndexRoute =
  PrivateDashboardBaseClientesEditarIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBaseClientesEditarIdLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesModelosCadastrarModalRoute =
  PrivateDashboardTrucksCaminhoesModelosCadastrarModalRouteImport.update({
    id: '/modelos/cadastrar/modal',
    path: '/modelos/cadastrar/modal',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesMarcasCadastrarModalRoute =
  PrivateDashboardTrucksCaminhoesMarcasCadastrarModalRouteImport.update({
    id: '/marcas/cadastrar/modal',
    path: '/marcas/cadastrar/modal',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesImplementosCadastrarModalRoute =
  PrivateDashboardTrucksCaminhoesImplementosCadastrarModalRouteImport.update({
    id: '/implementos/cadastrar/modal',
    path: '/implementos/cadastrar/modal',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesEditarIdModalRoute =
  PrivateDashboardTrucksCaminhoesEditarIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesEditarIdLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesCarregamentosCadastrarModalRoute =
  PrivateDashboardTrucksCaminhoesCarregamentosCadastrarModalRouteImport.update({
    id: '/carregamentos/cadastrar/modal',
    path: '/carregamentos/cadastrar/modal',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardSettingsConfiguracoesTermosIdModalRoute =
  PrivateDashboardSettingsConfiguracoesTermosIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () =>
      PrivateDashboardSettingsConfiguracoesTermosIdLayoutRoute,
  } as any)
const PrivateDashboardSettingsConfiguracoesPopupsIdModalRoute =
  PrivateDashboardSettingsConfiguracoesPopupsIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () =>
      PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRoute,
  } as any)
const PrivateDashboardBaseUsuariosEditarIdModalRoute =
  PrivateDashboardBaseUsuariosEditarIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () => PrivateDashboardBaseUsuariosEditarIdLayoutRoute,
  } as any)
const PrivateDashboardBaseTransportadorasFormsCadastrarModalRoute =
  PrivateDashboardBaseTransportadorasFormsCadastrarModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () =>
      PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRoute,
  } as any)
const PrivateDashboardBaseProdutosEditarIdModalRoute =
  PrivateDashboardBaseProdutosEditarIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () => PrivateDashboardBaseProdutosEditarIdLayoutRoute,
  } as any)
const PrivateDashboardBasePedidosEditarIdModalRoute =
  PrivateDashboardBasePedidosEditarIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () => PrivateDashboardBasePedidosEditarIdLayoutRoute,
  } as any)
const PrivateDashboardBaseMotoristasEditarIdModalRoute =
  PrivateDashboardBaseMotoristasEditarIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () => PrivateDashboardBaseMotoristasEditarIdLayoutRoute,
  } as any)
const PrivateDashboardBaseEmpresasEditarIdModalRoute =
  PrivateDashboardBaseEmpresasEditarIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () => PrivateDashboardBaseEmpresasEditarIdLayoutRoute,
  } as any)
const PrivateDashboardBaseClientesEditarIdModalRoute =
  PrivateDashboardBaseClientesEditarIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () => PrivateDashboardBaseClientesEditarIdLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRoute =
  PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRouteImport.update({
    id: '/modelos/editar/$id',
    path: '/modelos/editar/$id',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRoute =
  PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRouteImport.update({
    id: '/marcas/editar/$id',
    path: '/marcas/editar/$id',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRoute =
  PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRouteImport.update({
    id: '/implementos/editar/$id',
    path: '/implementos/editar/$id',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRoute =
  PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRouteImport.update({
    id: '/carregamentos/editar/$id',
    path: '/carregamentos/editar/$id',
    getParentRoute: () => PrivateDashboardTrucksCaminhoesLayoutRoute,
  } as any)
const PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRoute =
  PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRouteImport.update({
    id: '/editar/$id',
    path: '/editar/$id',
    getParentRoute: () => PrivateDashboardBaseTransportadorasFormsRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesModelosEditarIdIndexRoute =
  PrivateDashboardTrucksCaminhoesModelosEditarIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesMarcasEditarIdIndexRoute =
  PrivateDashboardTrucksCaminhoesMarcasEditarIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesImplementosEditarIdIndexRoute =
  PrivateDashboardTrucksCaminhoesImplementosEditarIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesCarregamentosEditarIdIndexRoute =
  PrivateDashboardTrucksCaminhoesCarregamentosEditarIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRoute,
  } as any)
const PrivateDashboardBaseTransportadorasFormsEditarIdIndexRoute =
  PrivateDashboardBaseTransportadorasFormsEditarIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesModelosEditarIdModalRoute =
  PrivateDashboardTrucksCaminhoesModelosEditarIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () =>
      PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesMarcasEditarIdModalRoute =
  PrivateDashboardTrucksCaminhoesMarcasEditarIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () =>
      PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesImplementosEditarIdModalRoute =
  PrivateDashboardTrucksCaminhoesImplementosEditarIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () =>
      PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRoute,
  } as any)
const PrivateDashboardTrucksCaminhoesCarregamentosEditarIdModalRoute =
  PrivateDashboardTrucksCaminhoesCarregamentosEditarIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () =>
      PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRoute,
  } as any)
const PrivateDashboardBaseTransportadorasFormsEditarIdModalRoute =
  PrivateDashboardBaseTransportadorasFormsEditarIdModalRouteImport.update({
    id: '/modal',
    path: '/modal',
    getParentRoute: () =>
      PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/dashboard': typeof PrivateDashboardLayoutRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/403': typeof Public403Route
  '/503': typeof Public503Route
  '/dashboard/conjuntos': typeof PrivateDashboardBaseConjuntosLayoutRouteWithChildren
  '/dashboard/logs': typeof PrivateDashboardBaseLogsLayoutRouteWithChildren
  '/dashboard/motoristas': typeof PrivateDashboardBaseMotoristasLayoutRouteWithChildren
  '/dashboard/produtos': typeof PrivateDashboardBaseProdutosLayoutRouteWithChildren
  '/dashboard/usuarios': typeof PrivateDashboardBaseUsuariosLayoutRouteWithChildren
  '/dashboard/configuracoes': typeof PrivateDashboardSettingsConfiguracoesLayoutRouteWithChildren
  '/dashboard/caminhoes': typeof PrivateDashboardTrucksCaminhoesLayoutRouteWithChildren
  '/dashboard/': typeof PrivateDashboardBaseIndexRoute
  '/dashboard/logs/$id': typeof PrivateDashboardBaseLogsIdLayoutRouteWithChildren
  '/dashboard/pedidos/$id': typeof PrivateDashboardBasePedidosIdLayoutRouteWithChildren
  '/dashboard/pedidos/cadastrar': typeof PrivateDashboardBasePedidosCadastrarLayoutRouteWithChildren
  '/dashboard/perfil/modal': typeof PrivateDashboardBasePerfilModalRoute
  '/dashboard/transportadoras': typeof PrivateDashboardBaseTransportadorasFormsRouteWithChildren
  '/dashboard/configuracoes/avisos': typeof PrivateDashboardSettingsConfiguracoesAvisosRoute
  '/dashboard/configuracoes/bloqueios': typeof PrivateDashboardSettingsConfiguracoesBloqueiosRoute
  '/dashboard/configuracoes/informacoes': typeof PrivateDashboardSettingsConfiguracoesInformacoesRoute
  '/dashboard/clientes/': typeof PrivateDashboardBaseClientesIndexRoute
  '/dashboard/conjuntos/': typeof PrivateDashboardBaseConjuntosIndexRoute
  '/dashboard/empresas/': typeof PrivateDashboardBaseEmpresasIndexRoute
  '/dashboard/fila/': typeof PrivateDashboardBaseFilaIndexRoute
  '/dashboard/logs/': typeof PrivateDashboardBaseLogsIndexRoute
  '/dashboard/motoristas/': typeof PrivateDashboardBaseMotoristasIndexRoute
  '/dashboard/pedidos/': typeof PrivateDashboardBasePedidosIndexRoute
  '/dashboard/perfil/': typeof PrivateDashboardBasePerfilIndexRoute
  '/dashboard/produtos/': typeof PrivateDashboardBaseProdutosIndexRoute
  '/dashboard/resgate/': typeof PrivateDashboardBaseResgateIndexRoute
  '/dashboard/transportadoras/': typeof PrivateDashboardBaseTransportadorasIndexRoute
  '/dashboard/usuarios/': typeof PrivateDashboardBaseUsuariosIndexRoute
  '/dashboard/configuracoes/': typeof PrivateDashboardSettingsConfiguracoesIndexRoute
  '/dashboard/caminhoes/': typeof PrivateDashboardTrucksCaminhoesIndexRoute
  '/dashboard/clientes/editar/$id': typeof PrivateDashboardBaseClientesEditarIdLayoutRouteWithChildren
  '/dashboard/empresas/editar/$id': typeof PrivateDashboardBaseEmpresasEditarIdLayoutRouteWithChildren
  '/dashboard/motoristas/editar/$id': typeof PrivateDashboardBaseMotoristasEditarIdLayoutRouteWithChildren
  '/dashboard/pedidos/editar/$id': typeof PrivateDashboardBasePedidosEditarIdLayoutRouteWithChildren
  '/dashboard/produtos/editar/$id': typeof PrivateDashboardBaseProdutosEditarIdLayoutRouteWithChildren
  '/dashboard/transportadoras/cadastrar': typeof PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRouteWithChildren
  '/dashboard/usuarios/editar/$id': typeof PrivateDashboardBaseUsuariosEditarIdLayoutRouteWithChildren
  '/dashboard/configuracoes/popups/$id': typeof PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRouteWithChildren
  '/dashboard/configuracoes/termos/$id': typeof PrivateDashboardSettingsConfiguracoesTermosIdLayoutRouteWithChildren
  '/dashboard/caminhoes/editar/$id': typeof PrivateDashboardTrucksCaminhoesEditarIdLayoutRouteWithChildren
  '/aprovar-termo/transportadora/empresa/$companyId/$userId': typeof PrivateAprovarTermoTransportadoraEmpresaCompanyIdUserIdRoute
  '/dashboard/clientes/cadastrar/modal': typeof PrivateDashboardBaseClientesCadastrarModalRoute
  '/dashboard/conjuntos/vincular/transportadora': typeof PrivateDashboardBaseConjuntosVincularTransportadoraRoute
  '/dashboard/empresas/cadastrar/modal': typeof PrivateDashboardBaseEmpresasCadastrarModalRoute
  '/dashboard/logs/$id/modal': typeof PrivateDashboardBaseLogsIdModalRoute
  '/dashboard/motoristas/cadastrar/modal': typeof PrivateDashboardBaseMotoristasCadastrarModalRoute
  '/dashboard/pedidos/$id/modal': typeof PrivateDashboardBasePedidosIdModalRoute
  '/dashboard/pedidos/cadastrar/modal': typeof PrivateDashboardBasePedidosCadastrarModalRoute
  '/dashboard/usuarios/cadastrar/modal': typeof PrivateDashboardBaseUsuariosCadastrarModalRoute
  '/dashboard/caminhoes/cadastrar/modal': typeof PrivateDashboardTrucksCaminhoesCadastrarModalRoute
  '/dashboard/clientes/cadastrar/': typeof PrivateDashboardBaseClientesCadastrarIndexRoute
  '/dashboard/clientes/editar/': typeof PrivateDashboardBaseClientesEditarIndexRoute
  '/dashboard/conjuntos/vincular/': typeof PrivateDashboardBaseConjuntosVincularIndexRoute
  '/dashboard/empresas/cadastrar/': typeof PrivateDashboardBaseEmpresasCadastrarIndexRoute
  '/dashboard/empresas/editar/': typeof PrivateDashboardBaseEmpresasEditarIndexRoute
  '/dashboard/logs/$id/': typeof PrivateDashboardBaseLogsIdIndexRoute
  '/dashboard/motoristas/cadastrar/': typeof PrivateDashboardBaseMotoristasCadastrarIndexRoute
  '/dashboard/motoristas/editar/': typeof PrivateDashboardBaseMotoristasEditarIndexRoute
  '/dashboard/pedidos/$id/': typeof PrivateDashboardBasePedidosIdIndexRoute
  '/dashboard/pedidos/cadastrar/': typeof PrivateDashboardBasePedidosCadastrarIndexRoute
  '/dashboard/pedidos/editar/': typeof PrivateDashboardBasePedidosEditarIndexRoute
  '/dashboard/produtos/editar/': typeof PrivateDashboardBaseProdutosEditarIndexRoute
  '/dashboard/usuarios/cadastrar/': typeof PrivateDashboardBaseUsuariosCadastrarIndexRoute
  '/dashboard/usuarios/editar/': typeof PrivateDashboardBaseUsuariosEditarIndexRoute
  '/dashboard/configuracoes/popups/': typeof PrivateDashboardSettingsConfiguracoesPopupsIndexRoute
  '/dashboard/configuracoes/termos/': typeof PrivateDashboardSettingsConfiguracoesTermosIndexRoute
  '/dashboard/caminhoes/cadastrar/': typeof PrivateDashboardTrucksCaminhoesCadastrarIndexRoute
  '/dashboard/caminhoes/carregamentos/': typeof PrivateDashboardTrucksCaminhoesCarregamentosIndexRoute
  '/dashboard/caminhoes/editar/': typeof PrivateDashboardTrucksCaminhoesEditarIndexRoute
  '/dashboard/caminhoes/implementos/': typeof PrivateDashboardTrucksCaminhoesImplementosIndexRoute
  '/dashboard/caminhoes/marcas/': typeof PrivateDashboardTrucksCaminhoesMarcasIndexRoute
  '/dashboard/caminhoes/modelos/': typeof PrivateDashboardTrucksCaminhoesModelosIndexRoute
  '/dashboard/transportadoras/editar/$id': typeof PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRouteWithChildren
  '/dashboard/caminhoes/carregamentos/editar/$id': typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRouteWithChildren
  '/dashboard/caminhoes/implementos/editar/$id': typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRouteWithChildren
  '/dashboard/caminhoes/marcas/editar/$id': typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRouteWithChildren
  '/dashboard/caminhoes/modelos/editar/$id': typeof PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRouteWithChildren
  '/dashboard/clientes/editar/$id/modal': typeof PrivateDashboardBaseClientesEditarIdModalRoute
  '/dashboard/empresas/editar/$id/modal': typeof PrivateDashboardBaseEmpresasEditarIdModalRoute
  '/dashboard/motoristas/editar/$id/modal': typeof PrivateDashboardBaseMotoristasEditarIdModalRoute
  '/dashboard/pedidos/editar/$id/modal': typeof PrivateDashboardBasePedidosEditarIdModalRoute
  '/dashboard/produtos/editar/$id/modal': typeof PrivateDashboardBaseProdutosEditarIdModalRoute
  '/dashboard/transportadoras/cadastrar/modal': typeof PrivateDashboardBaseTransportadorasFormsCadastrarModalRoute
  '/dashboard/usuarios/editar/$id/modal': typeof PrivateDashboardBaseUsuariosEditarIdModalRoute
  '/dashboard/configuracoes/popups/$id/modal': typeof PrivateDashboardSettingsConfiguracoesPopupsIdModalRoute
  '/dashboard/configuracoes/termos/$id/modal': typeof PrivateDashboardSettingsConfiguracoesTermosIdModalRoute
  '/dashboard/caminhoes/carregamentos/cadastrar/modal': typeof PrivateDashboardTrucksCaminhoesCarregamentosCadastrarModalRoute
  '/dashboard/caminhoes/editar/$id/modal': typeof PrivateDashboardTrucksCaminhoesEditarIdModalRoute
  '/dashboard/caminhoes/implementos/cadastrar/modal': typeof PrivateDashboardTrucksCaminhoesImplementosCadastrarModalRoute
  '/dashboard/caminhoes/marcas/cadastrar/modal': typeof PrivateDashboardTrucksCaminhoesMarcasCadastrarModalRoute
  '/dashboard/caminhoes/modelos/cadastrar/modal': typeof PrivateDashboardTrucksCaminhoesModelosCadastrarModalRoute
  '/dashboard/clientes/editar/$id/': typeof PrivateDashboardBaseClientesEditarIdIndexRoute
  '/dashboard/empresas/editar/$id/': typeof PrivateDashboardBaseEmpresasEditarIdIndexRoute
  '/dashboard/motoristas/editar/$id/': typeof PrivateDashboardBaseMotoristasEditarIdIndexRoute
  '/dashboard/pedidos/editar/$id/': typeof PrivateDashboardBasePedidosEditarIdIndexRoute
  '/dashboard/produtos/editar/$id/': typeof PrivateDashboardBaseProdutosEditarIdIndexRoute
  '/dashboard/transportadoras/cadastrar/': typeof PrivateDashboardBaseTransportadorasFormsCadastrarIndexRoute
  '/dashboard/transportadoras/editar/': typeof PrivateDashboardBaseTransportadorasFormsEditarIndexRoute
  '/dashboard/usuarios/editar/$id/': typeof PrivateDashboardBaseUsuariosEditarIdIndexRoute
  '/dashboard/configuracoes/popups/$id/': typeof PrivateDashboardSettingsConfiguracoesPopupsIdIndexRoute
  '/dashboard/configuracoes/termos/$id/': typeof PrivateDashboardSettingsConfiguracoesTermosIdIndexRoute
  '/dashboard/caminhoes/carregamentos/cadastrar/': typeof PrivateDashboardTrucksCaminhoesCarregamentosCadastrarIndexRoute
  '/dashboard/caminhoes/carregamentos/editar/': typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIndexRoute
  '/dashboard/caminhoes/editar/$id/': typeof PrivateDashboardTrucksCaminhoesEditarIdIndexRoute
  '/dashboard/caminhoes/implementos/cadastrar/': typeof PrivateDashboardTrucksCaminhoesImplementosCadastrarIndexRoute
  '/dashboard/caminhoes/implementos/editar/': typeof PrivateDashboardTrucksCaminhoesImplementosEditarIndexRoute
  '/dashboard/caminhoes/marcas/cadastrar/': typeof PrivateDashboardTrucksCaminhoesMarcasCadastrarIndexRoute
  '/dashboard/caminhoes/marcas/editar/': typeof PrivateDashboardTrucksCaminhoesMarcasEditarIndexRoute
  '/dashboard/caminhoes/modelos/cadastrar/': typeof PrivateDashboardTrucksCaminhoesModelosCadastrarIndexRoute
  '/dashboard/caminhoes/modelos/editar/': typeof PrivateDashboardTrucksCaminhoesModelosEditarIndexRoute
  '/dashboard/transportadoras/editar/$id/modal': typeof PrivateDashboardBaseTransportadorasFormsEditarIdModalRoute
  '/dashboard/caminhoes/carregamentos/editar/$id/modal': typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdModalRoute
  '/dashboard/caminhoes/implementos/editar/$id/modal': typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdModalRoute
  '/dashboard/caminhoes/marcas/editar/$id/modal': typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdModalRoute
  '/dashboard/caminhoes/modelos/editar/$id/modal': typeof PrivateDashboardTrucksCaminhoesModelosEditarIdModalRoute
  '/dashboard/transportadoras/editar/$id/': typeof PrivateDashboardBaseTransportadorasFormsEditarIdIndexRoute
  '/dashboard/caminhoes/carregamentos/editar/$id/': typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdIndexRoute
  '/dashboard/caminhoes/implementos/editar/$id/': typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdIndexRoute
  '/dashboard/caminhoes/marcas/editar/$id/': typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdIndexRoute
  '/dashboard/caminhoes/modelos/editar/$id/': typeof PrivateDashboardTrucksCaminhoesModelosEditarIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof PublicIndexRoute
  '/dashboard': typeof PrivateDashboardBaseIndexRoute
  '/login': typeof AuthLoginRoute
  '/403': typeof Public403Route
  '/503': typeof Public503Route
  '/dashboard/perfil/modal': typeof PrivateDashboardBasePerfilModalRoute
  '/dashboard/transportadoras': typeof PrivateDashboardBaseTransportadorasIndexRoute
  '/dashboard/configuracoes/avisos': typeof PrivateDashboardSettingsConfiguracoesAvisosRoute
  '/dashboard/configuracoes/bloqueios': typeof PrivateDashboardSettingsConfiguracoesBloqueiosRoute
  '/dashboard/configuracoes/informacoes': typeof PrivateDashboardSettingsConfiguracoesInformacoesRoute
  '/dashboard/clientes': typeof PrivateDashboardBaseClientesIndexRoute
  '/dashboard/conjuntos': typeof PrivateDashboardBaseConjuntosIndexRoute
  '/dashboard/empresas': typeof PrivateDashboardBaseEmpresasIndexRoute
  '/dashboard/fila': typeof PrivateDashboardBaseFilaIndexRoute
  '/dashboard/logs': typeof PrivateDashboardBaseLogsIndexRoute
  '/dashboard/motoristas': typeof PrivateDashboardBaseMotoristasIndexRoute
  '/dashboard/pedidos': typeof PrivateDashboardBasePedidosIndexRoute
  '/dashboard/perfil': typeof PrivateDashboardBasePerfilIndexRoute
  '/dashboard/produtos': typeof PrivateDashboardBaseProdutosIndexRoute
  '/dashboard/resgate': typeof PrivateDashboardBaseResgateIndexRoute
  '/dashboard/usuarios': typeof PrivateDashboardBaseUsuariosIndexRoute
  '/dashboard/configuracoes': typeof PrivateDashboardSettingsConfiguracoesIndexRoute
  '/dashboard/caminhoes': typeof PrivateDashboardTrucksCaminhoesIndexRoute
  '/aprovar-termo/transportadora/empresa/$companyId/$userId': typeof PrivateAprovarTermoTransportadoraEmpresaCompanyIdUserIdRoute
  '/dashboard/clientes/cadastrar/modal': typeof PrivateDashboardBaseClientesCadastrarModalRoute
  '/dashboard/conjuntos/vincular/transportadora': typeof PrivateDashboardBaseConjuntosVincularTransportadoraRoute
  '/dashboard/empresas/cadastrar/modal': typeof PrivateDashboardBaseEmpresasCadastrarModalRoute
  '/dashboard/logs/$id/modal': typeof PrivateDashboardBaseLogsIdModalRoute
  '/dashboard/motoristas/cadastrar/modal': typeof PrivateDashboardBaseMotoristasCadastrarModalRoute
  '/dashboard/pedidos/$id/modal': typeof PrivateDashboardBasePedidosIdModalRoute
  '/dashboard/pedidos/cadastrar/modal': typeof PrivateDashboardBasePedidosCadastrarModalRoute
  '/dashboard/usuarios/cadastrar/modal': typeof PrivateDashboardBaseUsuariosCadastrarModalRoute
  '/dashboard/caminhoes/cadastrar/modal': typeof PrivateDashboardTrucksCaminhoesCadastrarModalRoute
  '/dashboard/clientes/cadastrar': typeof PrivateDashboardBaseClientesCadastrarIndexRoute
  '/dashboard/clientes/editar': typeof PrivateDashboardBaseClientesEditarIndexRoute
  '/dashboard/conjuntos/vincular': typeof PrivateDashboardBaseConjuntosVincularIndexRoute
  '/dashboard/empresas/cadastrar': typeof PrivateDashboardBaseEmpresasCadastrarIndexRoute
  '/dashboard/empresas/editar': typeof PrivateDashboardBaseEmpresasEditarIndexRoute
  '/dashboard/logs/$id': typeof PrivateDashboardBaseLogsIdIndexRoute
  '/dashboard/motoristas/cadastrar': typeof PrivateDashboardBaseMotoristasCadastrarIndexRoute
  '/dashboard/motoristas/editar': typeof PrivateDashboardBaseMotoristasEditarIndexRoute
  '/dashboard/pedidos/$id': typeof PrivateDashboardBasePedidosIdIndexRoute
  '/dashboard/pedidos/cadastrar': typeof PrivateDashboardBasePedidosCadastrarIndexRoute
  '/dashboard/pedidos/editar': typeof PrivateDashboardBasePedidosEditarIndexRoute
  '/dashboard/produtos/editar': typeof PrivateDashboardBaseProdutosEditarIndexRoute
  '/dashboard/usuarios/cadastrar': typeof PrivateDashboardBaseUsuariosCadastrarIndexRoute
  '/dashboard/usuarios/editar': typeof PrivateDashboardBaseUsuariosEditarIndexRoute
  '/dashboard/configuracoes/popups': typeof PrivateDashboardSettingsConfiguracoesPopupsIndexRoute
  '/dashboard/configuracoes/termos': typeof PrivateDashboardSettingsConfiguracoesTermosIndexRoute
  '/dashboard/caminhoes/cadastrar': typeof PrivateDashboardTrucksCaminhoesCadastrarIndexRoute
  '/dashboard/caminhoes/carregamentos': typeof PrivateDashboardTrucksCaminhoesCarregamentosIndexRoute
  '/dashboard/caminhoes/editar': typeof PrivateDashboardTrucksCaminhoesEditarIndexRoute
  '/dashboard/caminhoes/implementos': typeof PrivateDashboardTrucksCaminhoesImplementosIndexRoute
  '/dashboard/caminhoes/marcas': typeof PrivateDashboardTrucksCaminhoesMarcasIndexRoute
  '/dashboard/caminhoes/modelos': typeof PrivateDashboardTrucksCaminhoesModelosIndexRoute
  '/dashboard/clientes/editar/$id/modal': typeof PrivateDashboardBaseClientesEditarIdModalRoute
  '/dashboard/empresas/editar/$id/modal': typeof PrivateDashboardBaseEmpresasEditarIdModalRoute
  '/dashboard/motoristas/editar/$id/modal': typeof PrivateDashboardBaseMotoristasEditarIdModalRoute
  '/dashboard/pedidos/editar/$id/modal': typeof PrivateDashboardBasePedidosEditarIdModalRoute
  '/dashboard/produtos/editar/$id/modal': typeof PrivateDashboardBaseProdutosEditarIdModalRoute
  '/dashboard/transportadoras/cadastrar/modal': typeof PrivateDashboardBaseTransportadorasFormsCadastrarModalRoute
  '/dashboard/usuarios/editar/$id/modal': typeof PrivateDashboardBaseUsuariosEditarIdModalRoute
  '/dashboard/configuracoes/popups/$id/modal': typeof PrivateDashboardSettingsConfiguracoesPopupsIdModalRoute
  '/dashboard/configuracoes/termos/$id/modal': typeof PrivateDashboardSettingsConfiguracoesTermosIdModalRoute
  '/dashboard/caminhoes/carregamentos/cadastrar/modal': typeof PrivateDashboardTrucksCaminhoesCarregamentosCadastrarModalRoute
  '/dashboard/caminhoes/editar/$id/modal': typeof PrivateDashboardTrucksCaminhoesEditarIdModalRoute
  '/dashboard/caminhoes/implementos/cadastrar/modal': typeof PrivateDashboardTrucksCaminhoesImplementosCadastrarModalRoute
  '/dashboard/caminhoes/marcas/cadastrar/modal': typeof PrivateDashboardTrucksCaminhoesMarcasCadastrarModalRoute
  '/dashboard/caminhoes/modelos/cadastrar/modal': typeof PrivateDashboardTrucksCaminhoesModelosCadastrarModalRoute
  '/dashboard/clientes/editar/$id': typeof PrivateDashboardBaseClientesEditarIdIndexRoute
  '/dashboard/empresas/editar/$id': typeof PrivateDashboardBaseEmpresasEditarIdIndexRoute
  '/dashboard/motoristas/editar/$id': typeof PrivateDashboardBaseMotoristasEditarIdIndexRoute
  '/dashboard/pedidos/editar/$id': typeof PrivateDashboardBasePedidosEditarIdIndexRoute
  '/dashboard/produtos/editar/$id': typeof PrivateDashboardBaseProdutosEditarIdIndexRoute
  '/dashboard/transportadoras/cadastrar': typeof PrivateDashboardBaseTransportadorasFormsCadastrarIndexRoute
  '/dashboard/transportadoras/editar': typeof PrivateDashboardBaseTransportadorasFormsEditarIndexRoute
  '/dashboard/usuarios/editar/$id': typeof PrivateDashboardBaseUsuariosEditarIdIndexRoute
  '/dashboard/configuracoes/popups/$id': typeof PrivateDashboardSettingsConfiguracoesPopupsIdIndexRoute
  '/dashboard/configuracoes/termos/$id': typeof PrivateDashboardSettingsConfiguracoesTermosIdIndexRoute
  '/dashboard/caminhoes/carregamentos/cadastrar': typeof PrivateDashboardTrucksCaminhoesCarregamentosCadastrarIndexRoute
  '/dashboard/caminhoes/carregamentos/editar': typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIndexRoute
  '/dashboard/caminhoes/editar/$id': typeof PrivateDashboardTrucksCaminhoesEditarIdIndexRoute
  '/dashboard/caminhoes/implementos/cadastrar': typeof PrivateDashboardTrucksCaminhoesImplementosCadastrarIndexRoute
  '/dashboard/caminhoes/implementos/editar': typeof PrivateDashboardTrucksCaminhoesImplementosEditarIndexRoute
  '/dashboard/caminhoes/marcas/cadastrar': typeof PrivateDashboardTrucksCaminhoesMarcasCadastrarIndexRoute
  '/dashboard/caminhoes/marcas/editar': typeof PrivateDashboardTrucksCaminhoesMarcasEditarIndexRoute
  '/dashboard/caminhoes/modelos/cadastrar': typeof PrivateDashboardTrucksCaminhoesModelosCadastrarIndexRoute
  '/dashboard/caminhoes/modelos/editar': typeof PrivateDashboardTrucksCaminhoesModelosEditarIndexRoute
  '/dashboard/transportadoras/editar/$id/modal': typeof PrivateDashboardBaseTransportadorasFormsEditarIdModalRoute
  '/dashboard/caminhoes/carregamentos/editar/$id/modal': typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdModalRoute
  '/dashboard/caminhoes/implementos/editar/$id/modal': typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdModalRoute
  '/dashboard/caminhoes/marcas/editar/$id/modal': typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdModalRoute
  '/dashboard/caminhoes/modelos/editar/$id/modal': typeof PrivateDashboardTrucksCaminhoesModelosEditarIdModalRoute
  '/dashboard/transportadoras/editar/$id': typeof PrivateDashboardBaseTransportadorasFormsEditarIdIndexRoute
  '/dashboard/caminhoes/carregamentos/editar/$id': typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdIndexRoute
  '/dashboard/caminhoes/implementos/editar/$id': typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdIndexRoute
  '/dashboard/caminhoes/marcas/editar/$id': typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdIndexRoute
  '/dashboard/caminhoes/modelos/editar/$id': typeof PrivateDashboardTrucksCaminhoesModelosEditarIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_private': typeof PrivateRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_private/dashboard': typeof PrivateDashboardLayoutRouteWithChildren
  '/_auth/login': typeof AuthLoginRoute
  '/_public/403': typeof Public403Route
  '/_public/503': typeof Public503Route
  '/_public/': typeof PublicIndexRoute
  '/_private/dashboard/_base': typeof PrivateDashboardBaseRouteWithChildren
  '/_private/dashboard/_settings': typeof PrivateDashboardSettingsRouteWithChildren
  '/_private/dashboard/_trucks': typeof PrivateDashboardTrucksRouteWithChildren
  '/_private/dashboard/_base/conjuntos': typeof PrivateDashboardBaseConjuntosLayoutRouteWithChildren
  '/_private/dashboard/_base/logs': typeof PrivateDashboardBaseLogsLayoutRouteWithChildren
  '/_private/dashboard/_base/motoristas': typeof PrivateDashboardBaseMotoristasLayoutRouteWithChildren
  '/_private/dashboard/_base/produtos': typeof PrivateDashboardBaseProdutosLayoutRouteWithChildren
  '/_private/dashboard/_base/usuarios': typeof PrivateDashboardBaseUsuariosLayoutRouteWithChildren
  '/_private/dashboard/_settings/configuracoes': typeof PrivateDashboardSettingsConfiguracoesLayoutRouteWithChildren
  '/_private/dashboard/_trucks/caminhoes': typeof PrivateDashboardTrucksCaminhoesLayoutRouteWithChildren
  '/_private/dashboard/_base/': typeof PrivateDashboardBaseIndexRoute
  '/_private/dashboard/_base/logs/$id': typeof PrivateDashboardBaseLogsIdLayoutRouteWithChildren
  '/_private/dashboard/_base/pedidos/$id': typeof PrivateDashboardBasePedidosIdLayoutRouteWithChildren
  '/_private/dashboard/_base/pedidos/cadastrar': typeof PrivateDashboardBasePedidosCadastrarLayoutRouteWithChildren
  '/_private/dashboard/_base/perfil/modal': typeof PrivateDashboardBasePerfilModalRoute
  '/_private/dashboard/_base/transportadoras/_forms': typeof PrivateDashboardBaseTransportadorasFormsRouteWithChildren
  '/_private/dashboard/_settings/configuracoes/avisos': typeof PrivateDashboardSettingsConfiguracoesAvisosRoute
  '/_private/dashboard/_settings/configuracoes/bloqueios': typeof PrivateDashboardSettingsConfiguracoesBloqueiosRoute
  '/_private/dashboard/_settings/configuracoes/informacoes': typeof PrivateDashboardSettingsConfiguracoesInformacoesRoute
  '/_private/dashboard/_base/clientes/': typeof PrivateDashboardBaseClientesIndexRoute
  '/_private/dashboard/_base/conjuntos/': typeof PrivateDashboardBaseConjuntosIndexRoute
  '/_private/dashboard/_base/empresas/': typeof PrivateDashboardBaseEmpresasIndexRoute
  '/_private/dashboard/_base/fila/': typeof PrivateDashboardBaseFilaIndexRoute
  '/_private/dashboard/_base/logs/': typeof PrivateDashboardBaseLogsIndexRoute
  '/_private/dashboard/_base/motoristas/': typeof PrivateDashboardBaseMotoristasIndexRoute
  '/_private/dashboard/_base/pedidos/': typeof PrivateDashboardBasePedidosIndexRoute
  '/_private/dashboard/_base/perfil/': typeof PrivateDashboardBasePerfilIndexRoute
  '/_private/dashboard/_base/produtos/': typeof PrivateDashboardBaseProdutosIndexRoute
  '/_private/dashboard/_base/resgate/': typeof PrivateDashboardBaseResgateIndexRoute
  '/_private/dashboard/_base/transportadoras/': typeof PrivateDashboardBaseTransportadorasIndexRoute
  '/_private/dashboard/_base/usuarios/': typeof PrivateDashboardBaseUsuariosIndexRoute
  '/_private/dashboard/_settings/configuracoes/': typeof PrivateDashboardSettingsConfiguracoesIndexRoute
  '/_private/dashboard/_trucks/caminhoes/': typeof PrivateDashboardTrucksCaminhoesIndexRoute
  '/_private/dashboard/_base/clientes/editar/$id': typeof PrivateDashboardBaseClientesEditarIdLayoutRouteWithChildren
  '/_private/dashboard/_base/empresas/editar/$id': typeof PrivateDashboardBaseEmpresasEditarIdLayoutRouteWithChildren
  '/_private/dashboard/_base/motoristas/editar/$id': typeof PrivateDashboardBaseMotoristasEditarIdLayoutRouteWithChildren
  '/_private/dashboard/_base/pedidos/editar/$id': typeof PrivateDashboardBasePedidosEditarIdLayoutRouteWithChildren
  '/_private/dashboard/_base/produtos/editar/$id': typeof PrivateDashboardBaseProdutosEditarIdLayoutRouteWithChildren
  '/_private/dashboard/_base/transportadoras/_forms/cadastrar': typeof PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRouteWithChildren
  '/_private/dashboard/_base/usuarios/editar/$id': typeof PrivateDashboardBaseUsuariosEditarIdLayoutRouteWithChildren
  '/_private/dashboard/_settings/configuracoes/popups/$id': typeof PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRouteWithChildren
  '/_private/dashboard/_settings/configuracoes/termos/$id': typeof PrivateDashboardSettingsConfiguracoesTermosIdLayoutRouteWithChildren
  '/_private/dashboard/_trucks/caminhoes/editar/$id': typeof PrivateDashboardTrucksCaminhoesEditarIdLayoutRouteWithChildren
  '/_private/aprovar-termo/transportadora/empresa/$companyId/$userId': typeof PrivateAprovarTermoTransportadoraEmpresaCompanyIdUserIdRoute
  '/_private/dashboard/_base/clientes/cadastrar/modal': typeof PrivateDashboardBaseClientesCadastrarModalRoute
  '/_private/dashboard/_base/conjuntos/vincular/transportadora': typeof PrivateDashboardBaseConjuntosVincularTransportadoraRoute
  '/_private/dashboard/_base/empresas/cadastrar/modal': typeof PrivateDashboardBaseEmpresasCadastrarModalRoute
  '/_private/dashboard/_base/logs/$id/modal': typeof PrivateDashboardBaseLogsIdModalRoute
  '/_private/dashboard/_base/motoristas/cadastrar/modal': typeof PrivateDashboardBaseMotoristasCadastrarModalRoute
  '/_private/dashboard/_base/pedidos/$id/modal': typeof PrivateDashboardBasePedidosIdModalRoute
  '/_private/dashboard/_base/pedidos/cadastrar/modal': typeof PrivateDashboardBasePedidosCadastrarModalRoute
  '/_private/dashboard/_base/usuarios/cadastrar/modal': typeof PrivateDashboardBaseUsuariosCadastrarModalRoute
  '/_private/dashboard/_trucks/caminhoes/cadastrar/modal': typeof PrivateDashboardTrucksCaminhoesCadastrarModalRoute
  '/_private/dashboard/_base/clientes/cadastrar/': typeof PrivateDashboardBaseClientesCadastrarIndexRoute
  '/_private/dashboard/_base/clientes/editar/': typeof PrivateDashboardBaseClientesEditarIndexRoute
  '/_private/dashboard/_base/conjuntos/vincular/': typeof PrivateDashboardBaseConjuntosVincularIndexRoute
  '/_private/dashboard/_base/empresas/cadastrar/': typeof PrivateDashboardBaseEmpresasCadastrarIndexRoute
  '/_private/dashboard/_base/empresas/editar/': typeof PrivateDashboardBaseEmpresasEditarIndexRoute
  '/_private/dashboard/_base/logs/$id/': typeof PrivateDashboardBaseLogsIdIndexRoute
  '/_private/dashboard/_base/motoristas/cadastrar/': typeof PrivateDashboardBaseMotoristasCadastrarIndexRoute
  '/_private/dashboard/_base/motoristas/editar/': typeof PrivateDashboardBaseMotoristasEditarIndexRoute
  '/_private/dashboard/_base/pedidos/$id/': typeof PrivateDashboardBasePedidosIdIndexRoute
  '/_private/dashboard/_base/pedidos/cadastrar/': typeof PrivateDashboardBasePedidosCadastrarIndexRoute
  '/_private/dashboard/_base/pedidos/editar/': typeof PrivateDashboardBasePedidosEditarIndexRoute
  '/_private/dashboard/_base/produtos/editar/': typeof PrivateDashboardBaseProdutosEditarIndexRoute
  '/_private/dashboard/_base/usuarios/cadastrar/': typeof PrivateDashboardBaseUsuariosCadastrarIndexRoute
  '/_private/dashboard/_base/usuarios/editar/': typeof PrivateDashboardBaseUsuariosEditarIndexRoute
  '/_private/dashboard/_settings/configuracoes/popups/': typeof PrivateDashboardSettingsConfiguracoesPopupsIndexRoute
  '/_private/dashboard/_settings/configuracoes/termos/': typeof PrivateDashboardSettingsConfiguracoesTermosIndexRoute
  '/_private/dashboard/_trucks/caminhoes/cadastrar/': typeof PrivateDashboardTrucksCaminhoesCadastrarIndexRoute
  '/_private/dashboard/_trucks/caminhoes/carregamentos/': typeof PrivateDashboardTrucksCaminhoesCarregamentosIndexRoute
  '/_private/dashboard/_trucks/caminhoes/editar/': typeof PrivateDashboardTrucksCaminhoesEditarIndexRoute
  '/_private/dashboard/_trucks/caminhoes/implementos/': typeof PrivateDashboardTrucksCaminhoesImplementosIndexRoute
  '/_private/dashboard/_trucks/caminhoes/marcas/': typeof PrivateDashboardTrucksCaminhoesMarcasIndexRoute
  '/_private/dashboard/_trucks/caminhoes/modelos/': typeof PrivateDashboardTrucksCaminhoesModelosIndexRoute
  '/_private/dashboard/_base/transportadoras/_forms/editar/$id': typeof PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRouteWithChildren
  '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id': typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRouteWithChildren
  '/_private/dashboard/_trucks/caminhoes/implementos/editar/$id': typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRouteWithChildren
  '/_private/dashboard/_trucks/caminhoes/marcas/editar/$id': typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRouteWithChildren
  '/_private/dashboard/_trucks/caminhoes/modelos/editar/$id': typeof PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRouteWithChildren
  '/_private/dashboard/_base/clientes/editar/$id/modal': typeof PrivateDashboardBaseClientesEditarIdModalRoute
  '/_private/dashboard/_base/empresas/editar/$id/modal': typeof PrivateDashboardBaseEmpresasEditarIdModalRoute
  '/_private/dashboard/_base/motoristas/editar/$id/modal': typeof PrivateDashboardBaseMotoristasEditarIdModalRoute
  '/_private/dashboard/_base/pedidos/editar/$id/modal': typeof PrivateDashboardBasePedidosEditarIdModalRoute
  '/_private/dashboard/_base/produtos/editar/$id/modal': typeof PrivateDashboardBaseProdutosEditarIdModalRoute
  '/_private/dashboard/_base/transportadoras/_forms/cadastrar/modal': typeof PrivateDashboardBaseTransportadorasFormsCadastrarModalRoute
  '/_private/dashboard/_base/usuarios/editar/$id/modal': typeof PrivateDashboardBaseUsuariosEditarIdModalRoute
  '/_private/dashboard/_settings/configuracoes/popups/$id/modal': typeof PrivateDashboardSettingsConfiguracoesPopupsIdModalRoute
  '/_private/dashboard/_settings/configuracoes/termos/$id/modal': typeof PrivateDashboardSettingsConfiguracoesTermosIdModalRoute
  '/_private/dashboard/_trucks/caminhoes/carregamentos/cadastrar/modal': typeof PrivateDashboardTrucksCaminhoesCarregamentosCadastrarModalRoute
  '/_private/dashboard/_trucks/caminhoes/editar/$id/modal': typeof PrivateDashboardTrucksCaminhoesEditarIdModalRoute
  '/_private/dashboard/_trucks/caminhoes/implementos/cadastrar/modal': typeof PrivateDashboardTrucksCaminhoesImplementosCadastrarModalRoute
  '/_private/dashboard/_trucks/caminhoes/marcas/cadastrar/modal': typeof PrivateDashboardTrucksCaminhoesMarcasCadastrarModalRoute
  '/_private/dashboard/_trucks/caminhoes/modelos/cadastrar/modal': typeof PrivateDashboardTrucksCaminhoesModelosCadastrarModalRoute
  '/_private/dashboard/_base/clientes/editar/$id/': typeof PrivateDashboardBaseClientesEditarIdIndexRoute
  '/_private/dashboard/_base/empresas/editar/$id/': typeof PrivateDashboardBaseEmpresasEditarIdIndexRoute
  '/_private/dashboard/_base/motoristas/editar/$id/': typeof PrivateDashboardBaseMotoristasEditarIdIndexRoute
  '/_private/dashboard/_base/pedidos/editar/$id/': typeof PrivateDashboardBasePedidosEditarIdIndexRoute
  '/_private/dashboard/_base/produtos/editar/$id/': typeof PrivateDashboardBaseProdutosEditarIdIndexRoute
  '/_private/dashboard/_base/transportadoras/_forms/cadastrar/': typeof PrivateDashboardBaseTransportadorasFormsCadastrarIndexRoute
  '/_private/dashboard/_base/transportadoras/_forms/editar/': typeof PrivateDashboardBaseTransportadorasFormsEditarIndexRoute
  '/_private/dashboard/_base/usuarios/editar/$id/': typeof PrivateDashboardBaseUsuariosEditarIdIndexRoute
  '/_private/dashboard/_settings/configuracoes/popups/$id/': typeof PrivateDashboardSettingsConfiguracoesPopupsIdIndexRoute
  '/_private/dashboard/_settings/configuracoes/termos/$id/': typeof PrivateDashboardSettingsConfiguracoesTermosIdIndexRoute
  '/_private/dashboard/_trucks/caminhoes/carregamentos/cadastrar/': typeof PrivateDashboardTrucksCaminhoesCarregamentosCadastrarIndexRoute
  '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/': typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIndexRoute
  '/_private/dashboard/_trucks/caminhoes/editar/$id/': typeof PrivateDashboardTrucksCaminhoesEditarIdIndexRoute
  '/_private/dashboard/_trucks/caminhoes/implementos/cadastrar/': typeof PrivateDashboardTrucksCaminhoesImplementosCadastrarIndexRoute
  '/_private/dashboard/_trucks/caminhoes/implementos/editar/': typeof PrivateDashboardTrucksCaminhoesImplementosEditarIndexRoute
  '/_private/dashboard/_trucks/caminhoes/marcas/cadastrar/': typeof PrivateDashboardTrucksCaminhoesMarcasCadastrarIndexRoute
  '/_private/dashboard/_trucks/caminhoes/marcas/editar/': typeof PrivateDashboardTrucksCaminhoesMarcasEditarIndexRoute
  '/_private/dashboard/_trucks/caminhoes/modelos/cadastrar/': typeof PrivateDashboardTrucksCaminhoesModelosCadastrarIndexRoute
  '/_private/dashboard/_trucks/caminhoes/modelos/editar/': typeof PrivateDashboardTrucksCaminhoesModelosEditarIndexRoute
  '/_private/dashboard/_base/transportadoras/_forms/editar/$id/modal': typeof PrivateDashboardBaseTransportadorasFormsEditarIdModalRoute
  '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id/modal': typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdModalRoute
  '/_private/dashboard/_trucks/caminhoes/implementos/editar/$id/modal': typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdModalRoute
  '/_private/dashboard/_trucks/caminhoes/marcas/editar/$id/modal': typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdModalRoute
  '/_private/dashboard/_trucks/caminhoes/modelos/editar/$id/modal': typeof PrivateDashboardTrucksCaminhoesModelosEditarIdModalRoute
  '/_private/dashboard/_base/transportadoras/_forms/editar/$id/': typeof PrivateDashboardBaseTransportadorasFormsEditarIdIndexRoute
  '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id/': typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdIndexRoute
  '/_private/dashboard/_trucks/caminhoes/implementos/editar/$id/': typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdIndexRoute
  '/_private/dashboard/_trucks/caminhoes/marcas/editar/$id/': typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdIndexRoute
  '/_private/dashboard/_trucks/caminhoes/modelos/editar/$id/': typeof PrivateDashboardTrucksCaminhoesModelosEditarIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/403'
    | '/503'
    | '/dashboard/conjuntos'
    | '/dashboard/logs'
    | '/dashboard/motoristas'
    | '/dashboard/produtos'
    | '/dashboard/usuarios'
    | '/dashboard/configuracoes'
    | '/dashboard/caminhoes'
    | '/dashboard/'
    | '/dashboard/logs/$id'
    | '/dashboard/pedidos/$id'
    | '/dashboard/pedidos/cadastrar'
    | '/dashboard/perfil/modal'
    | '/dashboard/transportadoras'
    | '/dashboard/configuracoes/avisos'
    | '/dashboard/configuracoes/bloqueios'
    | '/dashboard/configuracoes/informacoes'
    | '/dashboard/clientes/'
    | '/dashboard/conjuntos/'
    | '/dashboard/empresas/'
    | '/dashboard/fila/'
    | '/dashboard/logs/'
    | '/dashboard/motoristas/'
    | '/dashboard/pedidos/'
    | '/dashboard/perfil/'
    | '/dashboard/produtos/'
    | '/dashboard/resgate/'
    | '/dashboard/transportadoras/'
    | '/dashboard/usuarios/'
    | '/dashboard/configuracoes/'
    | '/dashboard/caminhoes/'
    | '/dashboard/clientes/editar/$id'
    | '/dashboard/empresas/editar/$id'
    | '/dashboard/motoristas/editar/$id'
    | '/dashboard/pedidos/editar/$id'
    | '/dashboard/produtos/editar/$id'
    | '/dashboard/transportadoras/cadastrar'
    | '/dashboard/usuarios/editar/$id'
    | '/dashboard/configuracoes/popups/$id'
    | '/dashboard/configuracoes/termos/$id'
    | '/dashboard/caminhoes/editar/$id'
    | '/aprovar-termo/transportadora/empresa/$companyId/$userId'
    | '/dashboard/clientes/cadastrar/modal'
    | '/dashboard/conjuntos/vincular/transportadora'
    | '/dashboard/empresas/cadastrar/modal'
    | '/dashboard/logs/$id/modal'
    | '/dashboard/motoristas/cadastrar/modal'
    | '/dashboard/pedidos/$id/modal'
    | '/dashboard/pedidos/cadastrar/modal'
    | '/dashboard/usuarios/cadastrar/modal'
    | '/dashboard/caminhoes/cadastrar/modal'
    | '/dashboard/clientes/cadastrar/'
    | '/dashboard/clientes/editar/'
    | '/dashboard/conjuntos/vincular/'
    | '/dashboard/empresas/cadastrar/'
    | '/dashboard/empresas/editar/'
    | '/dashboard/logs/$id/'
    | '/dashboard/motoristas/cadastrar/'
    | '/dashboard/motoristas/editar/'
    | '/dashboard/pedidos/$id/'
    | '/dashboard/pedidos/cadastrar/'
    | '/dashboard/pedidos/editar/'
    | '/dashboard/produtos/editar/'
    | '/dashboard/usuarios/cadastrar/'
    | '/dashboard/usuarios/editar/'
    | '/dashboard/configuracoes/popups/'
    | '/dashboard/configuracoes/termos/'
    | '/dashboard/caminhoes/cadastrar/'
    | '/dashboard/caminhoes/carregamentos/'
    | '/dashboard/caminhoes/editar/'
    | '/dashboard/caminhoes/implementos/'
    | '/dashboard/caminhoes/marcas/'
    | '/dashboard/caminhoes/modelos/'
    | '/dashboard/transportadoras/editar/$id'
    | '/dashboard/caminhoes/carregamentos/editar/$id'
    | '/dashboard/caminhoes/implementos/editar/$id'
    | '/dashboard/caminhoes/marcas/editar/$id'
    | '/dashboard/caminhoes/modelos/editar/$id'
    | '/dashboard/clientes/editar/$id/modal'
    | '/dashboard/empresas/editar/$id/modal'
    | '/dashboard/motoristas/editar/$id/modal'
    | '/dashboard/pedidos/editar/$id/modal'
    | '/dashboard/produtos/editar/$id/modal'
    | '/dashboard/transportadoras/cadastrar/modal'
    | '/dashboard/usuarios/editar/$id/modal'
    | '/dashboard/configuracoes/popups/$id/modal'
    | '/dashboard/configuracoes/termos/$id/modal'
    | '/dashboard/caminhoes/carregamentos/cadastrar/modal'
    | '/dashboard/caminhoes/editar/$id/modal'
    | '/dashboard/caminhoes/implementos/cadastrar/modal'
    | '/dashboard/caminhoes/marcas/cadastrar/modal'
    | '/dashboard/caminhoes/modelos/cadastrar/modal'
    | '/dashboard/clientes/editar/$id/'
    | '/dashboard/empresas/editar/$id/'
    | '/dashboard/motoristas/editar/$id/'
    | '/dashboard/pedidos/editar/$id/'
    | '/dashboard/produtos/editar/$id/'
    | '/dashboard/transportadoras/cadastrar/'
    | '/dashboard/transportadoras/editar/'
    | '/dashboard/usuarios/editar/$id/'
    | '/dashboard/configuracoes/popups/$id/'
    | '/dashboard/configuracoes/termos/$id/'
    | '/dashboard/caminhoes/carregamentos/cadastrar/'
    | '/dashboard/caminhoes/carregamentos/editar/'
    | '/dashboard/caminhoes/editar/$id/'
    | '/dashboard/caminhoes/implementos/cadastrar/'
    | '/dashboard/caminhoes/implementos/editar/'
    | '/dashboard/caminhoes/marcas/cadastrar/'
    | '/dashboard/caminhoes/marcas/editar/'
    | '/dashboard/caminhoes/modelos/cadastrar/'
    | '/dashboard/caminhoes/modelos/editar/'
    | '/dashboard/transportadoras/editar/$id/modal'
    | '/dashboard/caminhoes/carregamentos/editar/$id/modal'
    | '/dashboard/caminhoes/implementos/editar/$id/modal'
    | '/dashboard/caminhoes/marcas/editar/$id/modal'
    | '/dashboard/caminhoes/modelos/editar/$id/modal'
    | '/dashboard/transportadoras/editar/$id/'
    | '/dashboard/caminhoes/carregamentos/editar/$id/'
    | '/dashboard/caminhoes/implementos/editar/$id/'
    | '/dashboard/caminhoes/marcas/editar/$id/'
    | '/dashboard/caminhoes/modelos/editar/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/login'
    | '/403'
    | '/503'
    | '/dashboard/perfil/modal'
    | '/dashboard/transportadoras'
    | '/dashboard/configuracoes/avisos'
    | '/dashboard/configuracoes/bloqueios'
    | '/dashboard/configuracoes/informacoes'
    | '/dashboard/clientes'
    | '/dashboard/conjuntos'
    | '/dashboard/empresas'
    | '/dashboard/fila'
    | '/dashboard/logs'
    | '/dashboard/motoristas'
    | '/dashboard/pedidos'
    | '/dashboard/perfil'
    | '/dashboard/produtos'
    | '/dashboard/resgate'
    | '/dashboard/usuarios'
    | '/dashboard/configuracoes'
    | '/dashboard/caminhoes'
    | '/aprovar-termo/transportadora/empresa/$companyId/$userId'
    | '/dashboard/clientes/cadastrar/modal'
    | '/dashboard/conjuntos/vincular/transportadora'
    | '/dashboard/empresas/cadastrar/modal'
    | '/dashboard/logs/$id/modal'
    | '/dashboard/motoristas/cadastrar/modal'
    | '/dashboard/pedidos/$id/modal'
    | '/dashboard/pedidos/cadastrar/modal'
    | '/dashboard/usuarios/cadastrar/modal'
    | '/dashboard/caminhoes/cadastrar/modal'
    | '/dashboard/clientes/cadastrar'
    | '/dashboard/clientes/editar'
    | '/dashboard/conjuntos/vincular'
    | '/dashboard/empresas/cadastrar'
    | '/dashboard/empresas/editar'
    | '/dashboard/logs/$id'
    | '/dashboard/motoristas/cadastrar'
    | '/dashboard/motoristas/editar'
    | '/dashboard/pedidos/$id'
    | '/dashboard/pedidos/cadastrar'
    | '/dashboard/pedidos/editar'
    | '/dashboard/produtos/editar'
    | '/dashboard/usuarios/cadastrar'
    | '/dashboard/usuarios/editar'
    | '/dashboard/configuracoes/popups'
    | '/dashboard/configuracoes/termos'
    | '/dashboard/caminhoes/cadastrar'
    | '/dashboard/caminhoes/carregamentos'
    | '/dashboard/caminhoes/editar'
    | '/dashboard/caminhoes/implementos'
    | '/dashboard/caminhoes/marcas'
    | '/dashboard/caminhoes/modelos'
    | '/dashboard/clientes/editar/$id/modal'
    | '/dashboard/empresas/editar/$id/modal'
    | '/dashboard/motoristas/editar/$id/modal'
    | '/dashboard/pedidos/editar/$id/modal'
    | '/dashboard/produtos/editar/$id/modal'
    | '/dashboard/transportadoras/cadastrar/modal'
    | '/dashboard/usuarios/editar/$id/modal'
    | '/dashboard/configuracoes/popups/$id/modal'
    | '/dashboard/configuracoes/termos/$id/modal'
    | '/dashboard/caminhoes/carregamentos/cadastrar/modal'
    | '/dashboard/caminhoes/editar/$id/modal'
    | '/dashboard/caminhoes/implementos/cadastrar/modal'
    | '/dashboard/caminhoes/marcas/cadastrar/modal'
    | '/dashboard/caminhoes/modelos/cadastrar/modal'
    | '/dashboard/clientes/editar/$id'
    | '/dashboard/empresas/editar/$id'
    | '/dashboard/motoristas/editar/$id'
    | '/dashboard/pedidos/editar/$id'
    | '/dashboard/produtos/editar/$id'
    | '/dashboard/transportadoras/cadastrar'
    | '/dashboard/transportadoras/editar'
    | '/dashboard/usuarios/editar/$id'
    | '/dashboard/configuracoes/popups/$id'
    | '/dashboard/configuracoes/termos/$id'
    | '/dashboard/caminhoes/carregamentos/cadastrar'
    | '/dashboard/caminhoes/carregamentos/editar'
    | '/dashboard/caminhoes/editar/$id'
    | '/dashboard/caminhoes/implementos/cadastrar'
    | '/dashboard/caminhoes/implementos/editar'
    | '/dashboard/caminhoes/marcas/cadastrar'
    | '/dashboard/caminhoes/marcas/editar'
    | '/dashboard/caminhoes/modelos/cadastrar'
    | '/dashboard/caminhoes/modelos/editar'
    | '/dashboard/transportadoras/editar/$id/modal'
    | '/dashboard/caminhoes/carregamentos/editar/$id/modal'
    | '/dashboard/caminhoes/implementos/editar/$id/modal'
    | '/dashboard/caminhoes/marcas/editar/$id/modal'
    | '/dashboard/caminhoes/modelos/editar/$id/modal'
    | '/dashboard/transportadoras/editar/$id'
    | '/dashboard/caminhoes/carregamentos/editar/$id'
    | '/dashboard/caminhoes/implementos/editar/$id'
    | '/dashboard/caminhoes/marcas/editar/$id'
    | '/dashboard/caminhoes/modelos/editar/$id'
  id:
    | '__root__'
    | '/_auth'
    | '/_private'
    | '/_public'
    | '/_private/dashboard'
    | '/_auth/login'
    | '/_public/403'
    | '/_public/503'
    | '/_public/'
    | '/_private/dashboard/_base'
    | '/_private/dashboard/_settings'
    | '/_private/dashboard/_trucks'
    | '/_private/dashboard/_base/conjuntos'
    | '/_private/dashboard/_base/logs'
    | '/_private/dashboard/_base/motoristas'
    | '/_private/dashboard/_base/produtos'
    | '/_private/dashboard/_base/usuarios'
    | '/_private/dashboard/_settings/configuracoes'
    | '/_private/dashboard/_trucks/caminhoes'
    | '/_private/dashboard/_base/'
    | '/_private/dashboard/_base/logs/$id'
    | '/_private/dashboard/_base/pedidos/$id'
    | '/_private/dashboard/_base/pedidos/cadastrar'
    | '/_private/dashboard/_base/perfil/modal'
    | '/_private/dashboard/_base/transportadoras/_forms'
    | '/_private/dashboard/_settings/configuracoes/avisos'
    | '/_private/dashboard/_settings/configuracoes/bloqueios'
    | '/_private/dashboard/_settings/configuracoes/informacoes'
    | '/_private/dashboard/_base/clientes/'
    | '/_private/dashboard/_base/conjuntos/'
    | '/_private/dashboard/_base/empresas/'
    | '/_private/dashboard/_base/fila/'
    | '/_private/dashboard/_base/logs/'
    | '/_private/dashboard/_base/motoristas/'
    | '/_private/dashboard/_base/pedidos/'
    | '/_private/dashboard/_base/perfil/'
    | '/_private/dashboard/_base/produtos/'
    | '/_private/dashboard/_base/resgate/'
    | '/_private/dashboard/_base/transportadoras/'
    | '/_private/dashboard/_base/usuarios/'
    | '/_private/dashboard/_settings/configuracoes/'
    | '/_private/dashboard/_trucks/caminhoes/'
    | '/_private/dashboard/_base/clientes/editar/$id'
    | '/_private/dashboard/_base/empresas/editar/$id'
    | '/_private/dashboard/_base/motoristas/editar/$id'
    | '/_private/dashboard/_base/pedidos/editar/$id'
    | '/_private/dashboard/_base/produtos/editar/$id'
    | '/_private/dashboard/_base/transportadoras/_forms/cadastrar'
    | '/_private/dashboard/_base/usuarios/editar/$id'
    | '/_private/dashboard/_settings/configuracoes/popups/$id'
    | '/_private/dashboard/_settings/configuracoes/termos/$id'
    | '/_private/dashboard/_trucks/caminhoes/editar/$id'
    | '/_private/aprovar-termo/transportadora/empresa/$companyId/$userId'
    | '/_private/dashboard/_base/clientes/cadastrar/modal'
    | '/_private/dashboard/_base/conjuntos/vincular/transportadora'
    | '/_private/dashboard/_base/empresas/cadastrar/modal'
    | '/_private/dashboard/_base/logs/$id/modal'
    | '/_private/dashboard/_base/motoristas/cadastrar/modal'
    | '/_private/dashboard/_base/pedidos/$id/modal'
    | '/_private/dashboard/_base/pedidos/cadastrar/modal'
    | '/_private/dashboard/_base/usuarios/cadastrar/modal'
    | '/_private/dashboard/_trucks/caminhoes/cadastrar/modal'
    | '/_private/dashboard/_base/clientes/cadastrar/'
    | '/_private/dashboard/_base/clientes/editar/'
    | '/_private/dashboard/_base/conjuntos/vincular/'
    | '/_private/dashboard/_base/empresas/cadastrar/'
    | '/_private/dashboard/_base/empresas/editar/'
    | '/_private/dashboard/_base/logs/$id/'
    | '/_private/dashboard/_base/motoristas/cadastrar/'
    | '/_private/dashboard/_base/motoristas/editar/'
    | '/_private/dashboard/_base/pedidos/$id/'
    | '/_private/dashboard/_base/pedidos/cadastrar/'
    | '/_private/dashboard/_base/pedidos/editar/'
    | '/_private/dashboard/_base/produtos/editar/'
    | '/_private/dashboard/_base/usuarios/cadastrar/'
    | '/_private/dashboard/_base/usuarios/editar/'
    | '/_private/dashboard/_settings/configuracoes/popups/'
    | '/_private/dashboard/_settings/configuracoes/termos/'
    | '/_private/dashboard/_trucks/caminhoes/cadastrar/'
    | '/_private/dashboard/_trucks/caminhoes/carregamentos/'
    | '/_private/dashboard/_trucks/caminhoes/editar/'
    | '/_private/dashboard/_trucks/caminhoes/implementos/'
    | '/_private/dashboard/_trucks/caminhoes/marcas/'
    | '/_private/dashboard/_trucks/caminhoes/modelos/'
    | '/_private/dashboard/_base/transportadoras/_forms/editar/$id'
    | '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id'
    | '/_private/dashboard/_trucks/caminhoes/implementos/editar/$id'
    | '/_private/dashboard/_trucks/caminhoes/marcas/editar/$id'
    | '/_private/dashboard/_trucks/caminhoes/modelos/editar/$id'
    | '/_private/dashboard/_base/clientes/editar/$id/modal'
    | '/_private/dashboard/_base/empresas/editar/$id/modal'
    | '/_private/dashboard/_base/motoristas/editar/$id/modal'
    | '/_private/dashboard/_base/pedidos/editar/$id/modal'
    | '/_private/dashboard/_base/produtos/editar/$id/modal'
    | '/_private/dashboard/_base/transportadoras/_forms/cadastrar/modal'
    | '/_private/dashboard/_base/usuarios/editar/$id/modal'
    | '/_private/dashboard/_settings/configuracoes/popups/$id/modal'
    | '/_private/dashboard/_settings/configuracoes/termos/$id/modal'
    | '/_private/dashboard/_trucks/caminhoes/carregamentos/cadastrar/modal'
    | '/_private/dashboard/_trucks/caminhoes/editar/$id/modal'
    | '/_private/dashboard/_trucks/caminhoes/implementos/cadastrar/modal'
    | '/_private/dashboard/_trucks/caminhoes/marcas/cadastrar/modal'
    | '/_private/dashboard/_trucks/caminhoes/modelos/cadastrar/modal'
    | '/_private/dashboard/_base/clientes/editar/$id/'
    | '/_private/dashboard/_base/empresas/editar/$id/'
    | '/_private/dashboard/_base/motoristas/editar/$id/'
    | '/_private/dashboard/_base/pedidos/editar/$id/'
    | '/_private/dashboard/_base/produtos/editar/$id/'
    | '/_private/dashboard/_base/transportadoras/_forms/cadastrar/'
    | '/_private/dashboard/_base/transportadoras/_forms/editar/'
    | '/_private/dashboard/_base/usuarios/editar/$id/'
    | '/_private/dashboard/_settings/configuracoes/popups/$id/'
    | '/_private/dashboard/_settings/configuracoes/termos/$id/'
    | '/_private/dashboard/_trucks/caminhoes/carregamentos/cadastrar/'
    | '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/'
    | '/_private/dashboard/_trucks/caminhoes/editar/$id/'
    | '/_private/dashboard/_trucks/caminhoes/implementos/cadastrar/'
    | '/_private/dashboard/_trucks/caminhoes/implementos/editar/'
    | '/_private/dashboard/_trucks/caminhoes/marcas/cadastrar/'
    | '/_private/dashboard/_trucks/caminhoes/marcas/editar/'
    | '/_private/dashboard/_trucks/caminhoes/modelos/cadastrar/'
    | '/_private/dashboard/_trucks/caminhoes/modelos/editar/'
    | '/_private/dashboard/_base/transportadoras/_forms/editar/$id/modal'
    | '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id/modal'
    | '/_private/dashboard/_trucks/caminhoes/implementos/editar/$id/modal'
    | '/_private/dashboard/_trucks/caminhoes/marcas/editar/$id/modal'
    | '/_private/dashboard/_trucks/caminhoes/modelos/editar/$id/modal'
    | '/_private/dashboard/_base/transportadoras/_forms/editar/$id/'
    | '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id/'
    | '/_private/dashboard/_trucks/caminhoes/implementos/editar/$id/'
    | '/_private/dashboard/_trucks/caminhoes/marcas/editar/$id/'
    | '/_private/dashboard/_trucks/caminhoes/modelos/editar/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  PrivateRoute: typeof PrivateRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PrivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/503': {
      id: '/_public/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof Public503RouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/403': {
      id: '/_public/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof Public403RouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_private/dashboard': {
      id: '/_private/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof PrivateDashboardLayoutRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/dashboard/_trucks': {
      id: '/_private/dashboard/_trucks'
      path: ''
      fullPath: '/dashboard'
      preLoaderRoute: typeof PrivateDashboardTrucksRouteImport
      parentRoute: typeof PrivateDashboardLayoutRoute
    }
    '/_private/dashboard/_settings': {
      id: '/_private/dashboard/_settings'
      path: ''
      fullPath: '/dashboard'
      preLoaderRoute: typeof PrivateDashboardSettingsRouteImport
      parentRoute: typeof PrivateDashboardLayoutRoute
    }
    '/_private/dashboard/_base': {
      id: '/_private/dashboard/_base'
      path: ''
      fullPath: '/dashboard'
      preLoaderRoute: typeof PrivateDashboardBaseRouteImport
      parentRoute: typeof PrivateDashboardLayoutRoute
    }
    '/_private/dashboard/_base/': {
      id: '/_private/dashboard/_base/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof PrivateDashboardBaseIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_trucks/caminhoes': {
      id: '/_private/dashboard/_trucks/caminhoes'
      path: '/caminhoes'
      fullPath: '/dashboard/caminhoes'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRouteImport
      parentRoute: typeof PrivateDashboardTrucksRoute
    }
    '/_private/dashboard/_settings/configuracoes': {
      id: '/_private/dashboard/_settings/configuracoes'
      path: '/configuracoes'
      fullPath: '/dashboard/configuracoes'
      preLoaderRoute: typeof PrivateDashboardSettingsConfiguracoesLayoutRouteImport
      parentRoute: typeof PrivateDashboardSettingsRoute
    }
    '/_private/dashboard/_base/usuarios': {
      id: '/_private/dashboard/_base/usuarios'
      path: '/usuarios'
      fullPath: '/dashboard/usuarios'
      preLoaderRoute: typeof PrivateDashboardBaseUsuariosLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/produtos': {
      id: '/_private/dashboard/_base/produtos'
      path: '/produtos'
      fullPath: '/dashboard/produtos'
      preLoaderRoute: typeof PrivateDashboardBaseProdutosLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/motoristas': {
      id: '/_private/dashboard/_base/motoristas'
      path: '/motoristas'
      fullPath: '/dashboard/motoristas'
      preLoaderRoute: typeof PrivateDashboardBaseMotoristasLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/logs': {
      id: '/_private/dashboard/_base/logs'
      path: '/logs'
      fullPath: '/dashboard/logs'
      preLoaderRoute: typeof PrivateDashboardBaseLogsLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/conjuntos': {
      id: '/_private/dashboard/_base/conjuntos'
      path: '/conjuntos'
      fullPath: '/dashboard/conjuntos'
      preLoaderRoute: typeof PrivateDashboardBaseConjuntosLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_trucks/caminhoes/': {
      id: '/_private/dashboard/_trucks/caminhoes/'
      path: '/'
      fullPath: '/dashboard/caminhoes/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_settings/configuracoes/': {
      id: '/_private/dashboard/_settings/configuracoes/'
      path: '/'
      fullPath: '/dashboard/configuracoes/'
      preLoaderRoute: typeof PrivateDashboardSettingsConfiguracoesIndexRouteImport
      parentRoute: typeof PrivateDashboardSettingsConfiguracoesLayoutRoute
    }
    '/_private/dashboard/_base/usuarios/': {
      id: '/_private/dashboard/_base/usuarios/'
      path: '/'
      fullPath: '/dashboard/usuarios/'
      preLoaderRoute: typeof PrivateDashboardBaseUsuariosIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseUsuariosLayoutRoute
    }
    '/_private/dashboard/_base/transportadoras/': {
      id: '/_private/dashboard/_base/transportadoras/'
      path: '/transportadoras'
      fullPath: '/dashboard/transportadoras/'
      preLoaderRoute: typeof PrivateDashboardBaseTransportadorasIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/resgate/': {
      id: '/_private/dashboard/_base/resgate/'
      path: '/resgate'
      fullPath: '/dashboard/resgate/'
      preLoaderRoute: typeof PrivateDashboardBaseResgateIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/produtos/': {
      id: '/_private/dashboard/_base/produtos/'
      path: '/'
      fullPath: '/dashboard/produtos/'
      preLoaderRoute: typeof PrivateDashboardBaseProdutosIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseProdutosLayoutRoute
    }
    '/_private/dashboard/_base/perfil/': {
      id: '/_private/dashboard/_base/perfil/'
      path: '/perfil'
      fullPath: '/dashboard/perfil/'
      preLoaderRoute: typeof PrivateDashboardBasePerfilIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/pedidos/': {
      id: '/_private/dashboard/_base/pedidos/'
      path: '/pedidos'
      fullPath: '/dashboard/pedidos/'
      preLoaderRoute: typeof PrivateDashboardBasePedidosIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/motoristas/': {
      id: '/_private/dashboard/_base/motoristas/'
      path: '/'
      fullPath: '/dashboard/motoristas/'
      preLoaderRoute: typeof PrivateDashboardBaseMotoristasIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseMotoristasLayoutRoute
    }
    '/_private/dashboard/_base/logs/': {
      id: '/_private/dashboard/_base/logs/'
      path: '/'
      fullPath: '/dashboard/logs/'
      preLoaderRoute: typeof PrivateDashboardBaseLogsIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseLogsLayoutRoute
    }
    '/_private/dashboard/_base/fila/': {
      id: '/_private/dashboard/_base/fila/'
      path: '/fila'
      fullPath: '/dashboard/fila/'
      preLoaderRoute: typeof PrivateDashboardBaseFilaIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/empresas/': {
      id: '/_private/dashboard/_base/empresas/'
      path: '/empresas'
      fullPath: '/dashboard/empresas/'
      preLoaderRoute: typeof PrivateDashboardBaseEmpresasIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/conjuntos/': {
      id: '/_private/dashboard/_base/conjuntos/'
      path: '/'
      fullPath: '/dashboard/conjuntos/'
      preLoaderRoute: typeof PrivateDashboardBaseConjuntosIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseConjuntosLayoutRoute
    }
    '/_private/dashboard/_base/clientes/': {
      id: '/_private/dashboard/_base/clientes/'
      path: '/clientes'
      fullPath: '/dashboard/clientes/'
      preLoaderRoute: typeof PrivateDashboardBaseClientesIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_settings/configuracoes/informacoes': {
      id: '/_private/dashboard/_settings/configuracoes/informacoes'
      path: '/informacoes'
      fullPath: '/dashboard/configuracoes/informacoes'
      preLoaderRoute: typeof PrivateDashboardSettingsConfiguracoesInformacoesRouteImport
      parentRoute: typeof PrivateDashboardSettingsConfiguracoesLayoutRoute
    }
    '/_private/dashboard/_settings/configuracoes/bloqueios': {
      id: '/_private/dashboard/_settings/configuracoes/bloqueios'
      path: '/bloqueios'
      fullPath: '/dashboard/configuracoes/bloqueios'
      preLoaderRoute: typeof PrivateDashboardSettingsConfiguracoesBloqueiosRouteImport
      parentRoute: typeof PrivateDashboardSettingsConfiguracoesLayoutRoute
    }
    '/_private/dashboard/_settings/configuracoes/avisos': {
      id: '/_private/dashboard/_settings/configuracoes/avisos'
      path: '/avisos'
      fullPath: '/dashboard/configuracoes/avisos'
      preLoaderRoute: typeof PrivateDashboardSettingsConfiguracoesAvisosRouteImport
      parentRoute: typeof PrivateDashboardSettingsConfiguracoesLayoutRoute
    }
    '/_private/dashboard/_base/transportadoras/_forms': {
      id: '/_private/dashboard/_base/transportadoras/_forms'
      path: '/transportadoras'
      fullPath: '/dashboard/transportadoras'
      preLoaderRoute: typeof PrivateDashboardBaseTransportadorasFormsRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/perfil/modal': {
      id: '/_private/dashboard/_base/perfil/modal'
      path: '/perfil/modal'
      fullPath: '/dashboard/perfil/modal'
      preLoaderRoute: typeof PrivateDashboardBasePerfilModalRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/pedidos/cadastrar': {
      id: '/_private/dashboard/_base/pedidos/cadastrar'
      path: '/pedidos/cadastrar'
      fullPath: '/dashboard/pedidos/cadastrar'
      preLoaderRoute: typeof PrivateDashboardBasePedidosCadastrarLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/pedidos/$id': {
      id: '/_private/dashboard/_base/pedidos/$id'
      path: '/pedidos/$id'
      fullPath: '/dashboard/pedidos/$id'
      preLoaderRoute: typeof PrivateDashboardBasePedidosIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/logs/$id': {
      id: '/_private/dashboard/_base/logs/$id'
      path: '/$id'
      fullPath: '/dashboard/logs/$id'
      preLoaderRoute: typeof PrivateDashboardBaseLogsIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseLogsLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/modelos/': {
      id: '/_private/dashboard/_trucks/caminhoes/modelos/'
      path: '/modelos'
      fullPath: '/dashboard/caminhoes/modelos/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesModelosIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/marcas/': {
      id: '/_private/dashboard/_trucks/caminhoes/marcas/'
      path: '/marcas'
      fullPath: '/dashboard/caminhoes/marcas/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesMarcasIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/implementos/': {
      id: '/_private/dashboard/_trucks/caminhoes/implementos/'
      path: '/implementos'
      fullPath: '/dashboard/caminhoes/implementos/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesImplementosIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/editar/': {
      id: '/_private/dashboard/_trucks/caminhoes/editar/'
      path: '/editar'
      fullPath: '/dashboard/caminhoes/editar/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesEditarIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/carregamentos/': {
      id: '/_private/dashboard/_trucks/caminhoes/carregamentos/'
      path: '/carregamentos'
      fullPath: '/dashboard/caminhoes/carregamentos/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/cadastrar/': {
      id: '/_private/dashboard/_trucks/caminhoes/cadastrar/'
      path: '/cadastrar'
      fullPath: '/dashboard/caminhoes/cadastrar/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesCadastrarIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_settings/configuracoes/termos/': {
      id: '/_private/dashboard/_settings/configuracoes/termos/'
      path: '/termos'
      fullPath: '/dashboard/configuracoes/termos/'
      preLoaderRoute: typeof PrivateDashboardSettingsConfiguracoesTermosIndexRouteImport
      parentRoute: typeof PrivateDashboardSettingsConfiguracoesLayoutRoute
    }
    '/_private/dashboard/_settings/configuracoes/popups/': {
      id: '/_private/dashboard/_settings/configuracoes/popups/'
      path: '/popups'
      fullPath: '/dashboard/configuracoes/popups/'
      preLoaderRoute: typeof PrivateDashboardSettingsConfiguracoesPopupsIndexRouteImport
      parentRoute: typeof PrivateDashboardSettingsConfiguracoesLayoutRoute
    }
    '/_private/dashboard/_base/usuarios/editar/': {
      id: '/_private/dashboard/_base/usuarios/editar/'
      path: '/editar'
      fullPath: '/dashboard/usuarios/editar/'
      preLoaderRoute: typeof PrivateDashboardBaseUsuariosEditarIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseUsuariosLayoutRoute
    }
    '/_private/dashboard/_base/usuarios/cadastrar/': {
      id: '/_private/dashboard/_base/usuarios/cadastrar/'
      path: '/cadastrar'
      fullPath: '/dashboard/usuarios/cadastrar/'
      preLoaderRoute: typeof PrivateDashboardBaseUsuariosCadastrarIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseUsuariosLayoutRoute
    }
    '/_private/dashboard/_base/produtos/editar/': {
      id: '/_private/dashboard/_base/produtos/editar/'
      path: '/editar'
      fullPath: '/dashboard/produtos/editar/'
      preLoaderRoute: typeof PrivateDashboardBaseProdutosEditarIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseProdutosLayoutRoute
    }
    '/_private/dashboard/_base/pedidos/editar/': {
      id: '/_private/dashboard/_base/pedidos/editar/'
      path: '/pedidos/editar'
      fullPath: '/dashboard/pedidos/editar/'
      preLoaderRoute: typeof PrivateDashboardBasePedidosEditarIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/pedidos/cadastrar/': {
      id: '/_private/dashboard/_base/pedidos/cadastrar/'
      path: '/'
      fullPath: '/dashboard/pedidos/cadastrar/'
      preLoaderRoute: typeof PrivateDashboardBasePedidosCadastrarIndexRouteImport
      parentRoute: typeof PrivateDashboardBasePedidosCadastrarLayoutRoute
    }
    '/_private/dashboard/_base/pedidos/$id/': {
      id: '/_private/dashboard/_base/pedidos/$id/'
      path: '/'
      fullPath: '/dashboard/pedidos/$id/'
      preLoaderRoute: typeof PrivateDashboardBasePedidosIdIndexRouteImport
      parentRoute: typeof PrivateDashboardBasePedidosIdLayoutRoute
    }
    '/_private/dashboard/_base/motoristas/editar/': {
      id: '/_private/dashboard/_base/motoristas/editar/'
      path: '/editar'
      fullPath: '/dashboard/motoristas/editar/'
      preLoaderRoute: typeof PrivateDashboardBaseMotoristasEditarIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseMotoristasLayoutRoute
    }
    '/_private/dashboard/_base/motoristas/cadastrar/': {
      id: '/_private/dashboard/_base/motoristas/cadastrar/'
      path: '/cadastrar'
      fullPath: '/dashboard/motoristas/cadastrar/'
      preLoaderRoute: typeof PrivateDashboardBaseMotoristasCadastrarIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseMotoristasLayoutRoute
    }
    '/_private/dashboard/_base/logs/$id/': {
      id: '/_private/dashboard/_base/logs/$id/'
      path: '/'
      fullPath: '/dashboard/logs/$id/'
      preLoaderRoute: typeof PrivateDashboardBaseLogsIdIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseLogsIdLayoutRoute
    }
    '/_private/dashboard/_base/empresas/editar/': {
      id: '/_private/dashboard/_base/empresas/editar/'
      path: '/empresas/editar'
      fullPath: '/dashboard/empresas/editar/'
      preLoaderRoute: typeof PrivateDashboardBaseEmpresasEditarIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/empresas/cadastrar/': {
      id: '/_private/dashboard/_base/empresas/cadastrar/'
      path: '/empresas/cadastrar'
      fullPath: '/dashboard/empresas/cadastrar/'
      preLoaderRoute: typeof PrivateDashboardBaseEmpresasCadastrarIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/conjuntos/vincular/': {
      id: '/_private/dashboard/_base/conjuntos/vincular/'
      path: '/vincular'
      fullPath: '/dashboard/conjuntos/vincular/'
      preLoaderRoute: typeof PrivateDashboardBaseConjuntosVincularIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseConjuntosLayoutRoute
    }
    '/_private/dashboard/_base/clientes/editar/': {
      id: '/_private/dashboard/_base/clientes/editar/'
      path: '/clientes/editar'
      fullPath: '/dashboard/clientes/editar/'
      preLoaderRoute: typeof PrivateDashboardBaseClientesEditarIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/clientes/cadastrar/': {
      id: '/_private/dashboard/_base/clientes/cadastrar/'
      path: '/clientes/cadastrar'
      fullPath: '/dashboard/clientes/cadastrar/'
      preLoaderRoute: typeof PrivateDashboardBaseClientesCadastrarIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_trucks/caminhoes/cadastrar/modal': {
      id: '/_private/dashboard/_trucks/caminhoes/cadastrar/modal'
      path: '/cadastrar/modal'
      fullPath: '/dashboard/caminhoes/cadastrar/modal'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesCadastrarModalRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_base/usuarios/cadastrar/modal': {
      id: '/_private/dashboard/_base/usuarios/cadastrar/modal'
      path: '/cadastrar/modal'
      fullPath: '/dashboard/usuarios/cadastrar/modal'
      preLoaderRoute: typeof PrivateDashboardBaseUsuariosCadastrarModalRouteImport
      parentRoute: typeof PrivateDashboardBaseUsuariosLayoutRoute
    }
    '/_private/dashboard/_base/pedidos/cadastrar/modal': {
      id: '/_private/dashboard/_base/pedidos/cadastrar/modal'
      path: '/modal'
      fullPath: '/dashboard/pedidos/cadastrar/modal'
      preLoaderRoute: typeof PrivateDashboardBasePedidosCadastrarModalRouteImport
      parentRoute: typeof PrivateDashboardBasePedidosCadastrarLayoutRoute
    }
    '/_private/dashboard/_base/pedidos/$id/modal': {
      id: '/_private/dashboard/_base/pedidos/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/pedidos/$id/modal'
      preLoaderRoute: typeof PrivateDashboardBasePedidosIdModalRouteImport
      parentRoute: typeof PrivateDashboardBasePedidosIdLayoutRoute
    }
    '/_private/dashboard/_base/motoristas/cadastrar/modal': {
      id: '/_private/dashboard/_base/motoristas/cadastrar/modal'
      path: '/cadastrar/modal'
      fullPath: '/dashboard/motoristas/cadastrar/modal'
      preLoaderRoute: typeof PrivateDashboardBaseMotoristasCadastrarModalRouteImport
      parentRoute: typeof PrivateDashboardBaseMotoristasLayoutRoute
    }
    '/_private/dashboard/_base/logs/$id/modal': {
      id: '/_private/dashboard/_base/logs/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/logs/$id/modal'
      preLoaderRoute: typeof PrivateDashboardBaseLogsIdModalRouteImport
      parentRoute: typeof PrivateDashboardBaseLogsIdLayoutRoute
    }
    '/_private/dashboard/_base/empresas/cadastrar/modal': {
      id: '/_private/dashboard/_base/empresas/cadastrar/modal'
      path: '/empresas/cadastrar/modal'
      fullPath: '/dashboard/empresas/cadastrar/modal'
      preLoaderRoute: typeof PrivateDashboardBaseEmpresasCadastrarModalRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/conjuntos/vincular/transportadora': {
      id: '/_private/dashboard/_base/conjuntos/vincular/transportadora'
      path: '/vincular/transportadora'
      fullPath: '/dashboard/conjuntos/vincular/transportadora'
      preLoaderRoute: typeof PrivateDashboardBaseConjuntosVincularTransportadoraRouteImport
      parentRoute: typeof PrivateDashboardBaseConjuntosLayoutRoute
    }
    '/_private/dashboard/_base/clientes/cadastrar/modal': {
      id: '/_private/dashboard/_base/clientes/cadastrar/modal'
      path: '/clientes/cadastrar/modal'
      fullPath: '/dashboard/clientes/cadastrar/modal'
      preLoaderRoute: typeof PrivateDashboardBaseClientesCadastrarModalRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/aprovar-termo/transportadora/empresa/$companyId/$userId': {
      id: '/_private/aprovar-termo/transportadora/empresa/$companyId/$userId'
      path: '/aprovar-termo/transportadora/empresa/$companyId/$userId'
      fullPath: '/aprovar-termo/transportadora/empresa/$companyId/$userId'
      preLoaderRoute: typeof PrivateAprovarTermoTransportadoraEmpresaCompanyIdUserIdRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/dashboard/_trucks/caminhoes/editar/$id': {
      id: '/_private/dashboard/_trucks/caminhoes/editar/$id'
      path: '/editar/$id'
      fullPath: '/dashboard/caminhoes/editar/$id'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesEditarIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_settings/configuracoes/termos/$id': {
      id: '/_private/dashboard/_settings/configuracoes/termos/$id'
      path: '/termos/$id'
      fullPath: '/dashboard/configuracoes/termos/$id'
      preLoaderRoute: typeof PrivateDashboardSettingsConfiguracoesTermosIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardSettingsConfiguracoesLayoutRoute
    }
    '/_private/dashboard/_settings/configuracoes/popups/$id': {
      id: '/_private/dashboard/_settings/configuracoes/popups/$id'
      path: '/popups/$id'
      fullPath: '/dashboard/configuracoes/popups/$id'
      preLoaderRoute: typeof PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardSettingsConfiguracoesLayoutRoute
    }
    '/_private/dashboard/_base/usuarios/editar/$id': {
      id: '/_private/dashboard/_base/usuarios/editar/$id'
      path: '/editar/$id'
      fullPath: '/dashboard/usuarios/editar/$id'
      preLoaderRoute: typeof PrivateDashboardBaseUsuariosEditarIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseUsuariosLayoutRoute
    }
    '/_private/dashboard/_base/transportadoras/_forms/cadastrar': {
      id: '/_private/dashboard/_base/transportadoras/_forms/cadastrar'
      path: '/cadastrar'
      fullPath: '/dashboard/transportadoras/cadastrar'
      preLoaderRoute: typeof PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseTransportadorasFormsRoute
    }
    '/_private/dashboard/_base/produtos/editar/$id': {
      id: '/_private/dashboard/_base/produtos/editar/$id'
      path: '/editar/$id'
      fullPath: '/dashboard/produtos/editar/$id'
      preLoaderRoute: typeof PrivateDashboardBaseProdutosEditarIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseProdutosLayoutRoute
    }
    '/_private/dashboard/_base/pedidos/editar/$id': {
      id: '/_private/dashboard/_base/pedidos/editar/$id'
      path: '/pedidos/editar/$id'
      fullPath: '/dashboard/pedidos/editar/$id'
      preLoaderRoute: typeof PrivateDashboardBasePedidosEditarIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/motoristas/editar/$id': {
      id: '/_private/dashboard/_base/motoristas/editar/$id'
      path: '/editar/$id'
      fullPath: '/dashboard/motoristas/editar/$id'
      preLoaderRoute: typeof PrivateDashboardBaseMotoristasEditarIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseMotoristasLayoutRoute
    }
    '/_private/dashboard/_base/empresas/editar/$id': {
      id: '/_private/dashboard/_base/empresas/editar/$id'
      path: '/empresas/editar/$id'
      fullPath: '/dashboard/empresas/editar/$id'
      preLoaderRoute: typeof PrivateDashboardBaseEmpresasEditarIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_base/clientes/editar/$id': {
      id: '/_private/dashboard/_base/clientes/editar/$id'
      path: '/clientes/editar/$id'
      fullPath: '/dashboard/clientes/editar/$id'
      preLoaderRoute: typeof PrivateDashboardBaseClientesEditarIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseRoute
    }
    '/_private/dashboard/_trucks/caminhoes/modelos/editar/': {
      id: '/_private/dashboard/_trucks/caminhoes/modelos/editar/'
      path: '/modelos/editar'
      fullPath: '/dashboard/caminhoes/modelos/editar/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesModelosEditarIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/modelos/cadastrar/': {
      id: '/_private/dashboard/_trucks/caminhoes/modelos/cadastrar/'
      path: '/modelos/cadastrar'
      fullPath: '/dashboard/caminhoes/modelos/cadastrar/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesModelosCadastrarIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/marcas/editar/': {
      id: '/_private/dashboard/_trucks/caminhoes/marcas/editar/'
      path: '/marcas/editar'
      fullPath: '/dashboard/caminhoes/marcas/editar/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesMarcasEditarIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/marcas/cadastrar/': {
      id: '/_private/dashboard/_trucks/caminhoes/marcas/cadastrar/'
      path: '/marcas/cadastrar'
      fullPath: '/dashboard/caminhoes/marcas/cadastrar/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesMarcasCadastrarIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/implementos/editar/': {
      id: '/_private/dashboard/_trucks/caminhoes/implementos/editar/'
      path: '/implementos/editar'
      fullPath: '/dashboard/caminhoes/implementos/editar/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesImplementosEditarIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/implementos/cadastrar/': {
      id: '/_private/dashboard/_trucks/caminhoes/implementos/cadastrar/'
      path: '/implementos/cadastrar'
      fullPath: '/dashboard/caminhoes/implementos/cadastrar/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesImplementosCadastrarIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/editar/$id/': {
      id: '/_private/dashboard/_trucks/caminhoes/editar/$id/'
      path: '/'
      fullPath: '/dashboard/caminhoes/editar/$id/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesEditarIdIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesEditarIdLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/': {
      id: '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/'
      path: '/carregamentos/editar'
      fullPath: '/dashboard/caminhoes/carregamentos/editar/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/carregamentos/cadastrar/': {
      id: '/_private/dashboard/_trucks/caminhoes/carregamentos/cadastrar/'
      path: '/carregamentos/cadastrar'
      fullPath: '/dashboard/caminhoes/carregamentos/cadastrar/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosCadastrarIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_settings/configuracoes/termos/$id/': {
      id: '/_private/dashboard/_settings/configuracoes/termos/$id/'
      path: '/'
      fullPath: '/dashboard/configuracoes/termos/$id/'
      preLoaderRoute: typeof PrivateDashboardSettingsConfiguracoesTermosIdIndexRouteImport
      parentRoute: typeof PrivateDashboardSettingsConfiguracoesTermosIdLayoutRoute
    }
    '/_private/dashboard/_settings/configuracoes/popups/$id/': {
      id: '/_private/dashboard/_settings/configuracoes/popups/$id/'
      path: '/'
      fullPath: '/dashboard/configuracoes/popups/$id/'
      preLoaderRoute: typeof PrivateDashboardSettingsConfiguracoesPopupsIdIndexRouteImport
      parentRoute: typeof PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRoute
    }
    '/_private/dashboard/_base/usuarios/editar/$id/': {
      id: '/_private/dashboard/_base/usuarios/editar/$id/'
      path: '/'
      fullPath: '/dashboard/usuarios/editar/$id/'
      preLoaderRoute: typeof PrivateDashboardBaseUsuariosEditarIdIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseUsuariosEditarIdLayoutRoute
    }
    '/_private/dashboard/_base/transportadoras/_forms/editar/': {
      id: '/_private/dashboard/_base/transportadoras/_forms/editar/'
      path: '/editar'
      fullPath: '/dashboard/transportadoras/editar/'
      preLoaderRoute: typeof PrivateDashboardBaseTransportadorasFormsEditarIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseTransportadorasFormsRoute
    }
    '/_private/dashboard/_base/transportadoras/_forms/cadastrar/': {
      id: '/_private/dashboard/_base/transportadoras/_forms/cadastrar/'
      path: '/'
      fullPath: '/dashboard/transportadoras/cadastrar/'
      preLoaderRoute: typeof PrivateDashboardBaseTransportadorasFormsCadastrarIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRoute
    }
    '/_private/dashboard/_base/produtos/editar/$id/': {
      id: '/_private/dashboard/_base/produtos/editar/$id/'
      path: '/'
      fullPath: '/dashboard/produtos/editar/$id/'
      preLoaderRoute: typeof PrivateDashboardBaseProdutosEditarIdIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseProdutosEditarIdLayoutRoute
    }
    '/_private/dashboard/_base/pedidos/editar/$id/': {
      id: '/_private/dashboard/_base/pedidos/editar/$id/'
      path: '/'
      fullPath: '/dashboard/pedidos/editar/$id/'
      preLoaderRoute: typeof PrivateDashboardBasePedidosEditarIdIndexRouteImport
      parentRoute: typeof PrivateDashboardBasePedidosEditarIdLayoutRoute
    }
    '/_private/dashboard/_base/motoristas/editar/$id/': {
      id: '/_private/dashboard/_base/motoristas/editar/$id/'
      path: '/'
      fullPath: '/dashboard/motoristas/editar/$id/'
      preLoaderRoute: typeof PrivateDashboardBaseMotoristasEditarIdIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseMotoristasEditarIdLayoutRoute
    }
    '/_private/dashboard/_base/empresas/editar/$id/': {
      id: '/_private/dashboard/_base/empresas/editar/$id/'
      path: '/'
      fullPath: '/dashboard/empresas/editar/$id/'
      preLoaderRoute: typeof PrivateDashboardBaseEmpresasEditarIdIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseEmpresasEditarIdLayoutRoute
    }
    '/_private/dashboard/_base/clientes/editar/$id/': {
      id: '/_private/dashboard/_base/clientes/editar/$id/'
      path: '/'
      fullPath: '/dashboard/clientes/editar/$id/'
      preLoaderRoute: typeof PrivateDashboardBaseClientesEditarIdIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseClientesEditarIdLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/modelos/cadastrar/modal': {
      id: '/_private/dashboard/_trucks/caminhoes/modelos/cadastrar/modal'
      path: '/modelos/cadastrar/modal'
      fullPath: '/dashboard/caminhoes/modelos/cadastrar/modal'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesModelosCadastrarModalRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/marcas/cadastrar/modal': {
      id: '/_private/dashboard/_trucks/caminhoes/marcas/cadastrar/modal'
      path: '/marcas/cadastrar/modal'
      fullPath: '/dashboard/caminhoes/marcas/cadastrar/modal'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesMarcasCadastrarModalRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/implementos/cadastrar/modal': {
      id: '/_private/dashboard/_trucks/caminhoes/implementos/cadastrar/modal'
      path: '/implementos/cadastrar/modal'
      fullPath: '/dashboard/caminhoes/implementos/cadastrar/modal'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesImplementosCadastrarModalRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/editar/$id/modal': {
      id: '/_private/dashboard/_trucks/caminhoes/editar/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/caminhoes/editar/$id/modal'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesEditarIdModalRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesEditarIdLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/carregamentos/cadastrar/modal': {
      id: '/_private/dashboard/_trucks/caminhoes/carregamentos/cadastrar/modal'
      path: '/carregamentos/cadastrar/modal'
      fullPath: '/dashboard/caminhoes/carregamentos/cadastrar/modal'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosCadastrarModalRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_settings/configuracoes/termos/$id/modal': {
      id: '/_private/dashboard/_settings/configuracoes/termos/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/configuracoes/termos/$id/modal'
      preLoaderRoute: typeof PrivateDashboardSettingsConfiguracoesTermosIdModalRouteImport
      parentRoute: typeof PrivateDashboardSettingsConfiguracoesTermosIdLayoutRoute
    }
    '/_private/dashboard/_settings/configuracoes/popups/$id/modal': {
      id: '/_private/dashboard/_settings/configuracoes/popups/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/configuracoes/popups/$id/modal'
      preLoaderRoute: typeof PrivateDashboardSettingsConfiguracoesPopupsIdModalRouteImport
      parentRoute: typeof PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRoute
    }
    '/_private/dashboard/_base/usuarios/editar/$id/modal': {
      id: '/_private/dashboard/_base/usuarios/editar/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/usuarios/editar/$id/modal'
      preLoaderRoute: typeof PrivateDashboardBaseUsuariosEditarIdModalRouteImport
      parentRoute: typeof PrivateDashboardBaseUsuariosEditarIdLayoutRoute
    }
    '/_private/dashboard/_base/transportadoras/_forms/cadastrar/modal': {
      id: '/_private/dashboard/_base/transportadoras/_forms/cadastrar/modal'
      path: '/modal'
      fullPath: '/dashboard/transportadoras/cadastrar/modal'
      preLoaderRoute: typeof PrivateDashboardBaseTransportadorasFormsCadastrarModalRouteImport
      parentRoute: typeof PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRoute
    }
    '/_private/dashboard/_base/produtos/editar/$id/modal': {
      id: '/_private/dashboard/_base/produtos/editar/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/produtos/editar/$id/modal'
      preLoaderRoute: typeof PrivateDashboardBaseProdutosEditarIdModalRouteImport
      parentRoute: typeof PrivateDashboardBaseProdutosEditarIdLayoutRoute
    }
    '/_private/dashboard/_base/pedidos/editar/$id/modal': {
      id: '/_private/dashboard/_base/pedidos/editar/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/pedidos/editar/$id/modal'
      preLoaderRoute: typeof PrivateDashboardBasePedidosEditarIdModalRouteImport
      parentRoute: typeof PrivateDashboardBasePedidosEditarIdLayoutRoute
    }
    '/_private/dashboard/_base/motoristas/editar/$id/modal': {
      id: '/_private/dashboard/_base/motoristas/editar/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/motoristas/editar/$id/modal'
      preLoaderRoute: typeof PrivateDashboardBaseMotoristasEditarIdModalRouteImport
      parentRoute: typeof PrivateDashboardBaseMotoristasEditarIdLayoutRoute
    }
    '/_private/dashboard/_base/empresas/editar/$id/modal': {
      id: '/_private/dashboard/_base/empresas/editar/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/empresas/editar/$id/modal'
      preLoaderRoute: typeof PrivateDashboardBaseEmpresasEditarIdModalRouteImport
      parentRoute: typeof PrivateDashboardBaseEmpresasEditarIdLayoutRoute
    }
    '/_private/dashboard/_base/clientes/editar/$id/modal': {
      id: '/_private/dashboard/_base/clientes/editar/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/clientes/editar/$id/modal'
      preLoaderRoute: typeof PrivateDashboardBaseClientesEditarIdModalRouteImport
      parentRoute: typeof PrivateDashboardBaseClientesEditarIdLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/modelos/editar/$id': {
      id: '/_private/dashboard/_trucks/caminhoes/modelos/editar/$id'
      path: '/modelos/editar/$id'
      fullPath: '/dashboard/caminhoes/modelos/editar/$id'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/marcas/editar/$id': {
      id: '/_private/dashboard/_trucks/caminhoes/marcas/editar/$id'
      path: '/marcas/editar/$id'
      fullPath: '/dashboard/caminhoes/marcas/editar/$id'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/implementos/editar/$id': {
      id: '/_private/dashboard/_trucks/caminhoes/implementos/editar/$id'
      path: '/implementos/editar/$id'
      fullPath: '/dashboard/caminhoes/implementos/editar/$id'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id': {
      id: '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id'
      path: '/carregamentos/editar/$id'
      fullPath: '/dashboard/caminhoes/carregamentos/editar/$id'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRoute
    }
    '/_private/dashboard/_base/transportadoras/_forms/editar/$id': {
      id: '/_private/dashboard/_base/transportadoras/_forms/editar/$id'
      path: '/editar/$id'
      fullPath: '/dashboard/transportadoras/editar/$id'
      preLoaderRoute: typeof PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRouteImport
      parentRoute: typeof PrivateDashboardBaseTransportadorasFormsRoute
    }
    '/_private/dashboard/_trucks/caminhoes/modelos/editar/$id/': {
      id: '/_private/dashboard/_trucks/caminhoes/modelos/editar/$id/'
      path: '/'
      fullPath: '/dashboard/caminhoes/modelos/editar/$id/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesModelosEditarIdIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/marcas/editar/$id/': {
      id: '/_private/dashboard/_trucks/caminhoes/marcas/editar/$id/'
      path: '/'
      fullPath: '/dashboard/caminhoes/marcas/editar/$id/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/implementos/editar/$id/': {
      id: '/_private/dashboard/_trucks/caminhoes/implementos/editar/$id/'
      path: '/'
      fullPath: '/dashboard/caminhoes/implementos/editar/$id/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id/': {
      id: '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id/'
      path: '/'
      fullPath: '/dashboard/caminhoes/carregamentos/editar/$id/'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdIndexRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRoute
    }
    '/_private/dashboard/_base/transportadoras/_forms/editar/$id/': {
      id: '/_private/dashboard/_base/transportadoras/_forms/editar/$id/'
      path: '/'
      fullPath: '/dashboard/transportadoras/editar/$id/'
      preLoaderRoute: typeof PrivateDashboardBaseTransportadorasFormsEditarIdIndexRouteImport
      parentRoute: typeof PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/modelos/editar/$id/modal': {
      id: '/_private/dashboard/_trucks/caminhoes/modelos/editar/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/caminhoes/modelos/editar/$id/modal'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesModelosEditarIdModalRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/marcas/editar/$id/modal': {
      id: '/_private/dashboard/_trucks/caminhoes/marcas/editar/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/caminhoes/marcas/editar/$id/modal'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdModalRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/implementos/editar/$id/modal': {
      id: '/_private/dashboard/_trucks/caminhoes/implementos/editar/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/caminhoes/implementos/editar/$id/modal'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdModalRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRoute
    }
    '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id/modal': {
      id: '/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/caminhoes/carregamentos/editar/$id/modal'
      preLoaderRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdModalRouteImport
      parentRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRoute
    }
    '/_private/dashboard/_base/transportadoras/_forms/editar/$id/modal': {
      id: '/_private/dashboard/_base/transportadoras/_forms/editar/$id/modal'
      path: '/modal'
      fullPath: '/dashboard/transportadoras/editar/$id/modal'
      preLoaderRoute: typeof PrivateDashboardBaseTransportadorasFormsEditarIdModalRouteImport
      parentRoute: typeof PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PrivateDashboardBaseConjuntosLayoutRouteChildren {
  PrivateDashboardBaseConjuntosIndexRoute: typeof PrivateDashboardBaseConjuntosIndexRoute
  PrivateDashboardBaseConjuntosVincularTransportadoraRoute: typeof PrivateDashboardBaseConjuntosVincularTransportadoraRoute
  PrivateDashboardBaseConjuntosVincularIndexRoute: typeof PrivateDashboardBaseConjuntosVincularIndexRoute
}

const PrivateDashboardBaseConjuntosLayoutRouteChildren: PrivateDashboardBaseConjuntosLayoutRouteChildren =
  {
    PrivateDashboardBaseConjuntosIndexRoute:
      PrivateDashboardBaseConjuntosIndexRoute,
    PrivateDashboardBaseConjuntosVincularTransportadoraRoute:
      PrivateDashboardBaseConjuntosVincularTransportadoraRoute,
    PrivateDashboardBaseConjuntosVincularIndexRoute:
      PrivateDashboardBaseConjuntosVincularIndexRoute,
  }

const PrivateDashboardBaseConjuntosLayoutRouteWithChildren =
  PrivateDashboardBaseConjuntosLayoutRoute._addFileChildren(
    PrivateDashboardBaseConjuntosLayoutRouteChildren,
  )

interface PrivateDashboardBaseLogsIdLayoutRouteChildren {
  PrivateDashboardBaseLogsIdModalRoute: typeof PrivateDashboardBaseLogsIdModalRoute
  PrivateDashboardBaseLogsIdIndexRoute: typeof PrivateDashboardBaseLogsIdIndexRoute
}

const PrivateDashboardBaseLogsIdLayoutRouteChildren: PrivateDashboardBaseLogsIdLayoutRouteChildren =
  {
    PrivateDashboardBaseLogsIdModalRoute: PrivateDashboardBaseLogsIdModalRoute,
    PrivateDashboardBaseLogsIdIndexRoute: PrivateDashboardBaseLogsIdIndexRoute,
  }

const PrivateDashboardBaseLogsIdLayoutRouteWithChildren =
  PrivateDashboardBaseLogsIdLayoutRoute._addFileChildren(
    PrivateDashboardBaseLogsIdLayoutRouteChildren,
  )

interface PrivateDashboardBaseLogsLayoutRouteChildren {
  PrivateDashboardBaseLogsIdLayoutRoute: typeof PrivateDashboardBaseLogsIdLayoutRouteWithChildren
  PrivateDashboardBaseLogsIndexRoute: typeof PrivateDashboardBaseLogsIndexRoute
}

const PrivateDashboardBaseLogsLayoutRouteChildren: PrivateDashboardBaseLogsLayoutRouteChildren =
  {
    PrivateDashboardBaseLogsIdLayoutRoute:
      PrivateDashboardBaseLogsIdLayoutRouteWithChildren,
    PrivateDashboardBaseLogsIndexRoute: PrivateDashboardBaseLogsIndexRoute,
  }

const PrivateDashboardBaseLogsLayoutRouteWithChildren =
  PrivateDashboardBaseLogsLayoutRoute._addFileChildren(
    PrivateDashboardBaseLogsLayoutRouteChildren,
  )

interface PrivateDashboardBaseMotoristasEditarIdLayoutRouteChildren {
  PrivateDashboardBaseMotoristasEditarIdModalRoute: typeof PrivateDashboardBaseMotoristasEditarIdModalRoute
  PrivateDashboardBaseMotoristasEditarIdIndexRoute: typeof PrivateDashboardBaseMotoristasEditarIdIndexRoute
}

const PrivateDashboardBaseMotoristasEditarIdLayoutRouteChildren: PrivateDashboardBaseMotoristasEditarIdLayoutRouteChildren =
  {
    PrivateDashboardBaseMotoristasEditarIdModalRoute:
      PrivateDashboardBaseMotoristasEditarIdModalRoute,
    PrivateDashboardBaseMotoristasEditarIdIndexRoute:
      PrivateDashboardBaseMotoristasEditarIdIndexRoute,
  }

const PrivateDashboardBaseMotoristasEditarIdLayoutRouteWithChildren =
  PrivateDashboardBaseMotoristasEditarIdLayoutRoute._addFileChildren(
    PrivateDashboardBaseMotoristasEditarIdLayoutRouteChildren,
  )

interface PrivateDashboardBaseMotoristasLayoutRouteChildren {
  PrivateDashboardBaseMotoristasIndexRoute: typeof PrivateDashboardBaseMotoristasIndexRoute
  PrivateDashboardBaseMotoristasEditarIdLayoutRoute: typeof PrivateDashboardBaseMotoristasEditarIdLayoutRouteWithChildren
  PrivateDashboardBaseMotoristasCadastrarModalRoute: typeof PrivateDashboardBaseMotoristasCadastrarModalRoute
  PrivateDashboardBaseMotoristasCadastrarIndexRoute: typeof PrivateDashboardBaseMotoristasCadastrarIndexRoute
  PrivateDashboardBaseMotoristasEditarIndexRoute: typeof PrivateDashboardBaseMotoristasEditarIndexRoute
}

const PrivateDashboardBaseMotoristasLayoutRouteChildren: PrivateDashboardBaseMotoristasLayoutRouteChildren =
  {
    PrivateDashboardBaseMotoristasIndexRoute:
      PrivateDashboardBaseMotoristasIndexRoute,
    PrivateDashboardBaseMotoristasEditarIdLayoutRoute:
      PrivateDashboardBaseMotoristasEditarIdLayoutRouteWithChildren,
    PrivateDashboardBaseMotoristasCadastrarModalRoute:
      PrivateDashboardBaseMotoristasCadastrarModalRoute,
    PrivateDashboardBaseMotoristasCadastrarIndexRoute:
      PrivateDashboardBaseMotoristasCadastrarIndexRoute,
    PrivateDashboardBaseMotoristasEditarIndexRoute:
      PrivateDashboardBaseMotoristasEditarIndexRoute,
  }

const PrivateDashboardBaseMotoristasLayoutRouteWithChildren =
  PrivateDashboardBaseMotoristasLayoutRoute._addFileChildren(
    PrivateDashboardBaseMotoristasLayoutRouteChildren,
  )

interface PrivateDashboardBaseProdutosEditarIdLayoutRouteChildren {
  PrivateDashboardBaseProdutosEditarIdModalRoute: typeof PrivateDashboardBaseProdutosEditarIdModalRoute
  PrivateDashboardBaseProdutosEditarIdIndexRoute: typeof PrivateDashboardBaseProdutosEditarIdIndexRoute
}

const PrivateDashboardBaseProdutosEditarIdLayoutRouteChildren: PrivateDashboardBaseProdutosEditarIdLayoutRouteChildren =
  {
    PrivateDashboardBaseProdutosEditarIdModalRoute:
      PrivateDashboardBaseProdutosEditarIdModalRoute,
    PrivateDashboardBaseProdutosEditarIdIndexRoute:
      PrivateDashboardBaseProdutosEditarIdIndexRoute,
  }

const PrivateDashboardBaseProdutosEditarIdLayoutRouteWithChildren =
  PrivateDashboardBaseProdutosEditarIdLayoutRoute._addFileChildren(
    PrivateDashboardBaseProdutosEditarIdLayoutRouteChildren,
  )

interface PrivateDashboardBaseProdutosLayoutRouteChildren {
  PrivateDashboardBaseProdutosIndexRoute: typeof PrivateDashboardBaseProdutosIndexRoute
  PrivateDashboardBaseProdutosEditarIdLayoutRoute: typeof PrivateDashboardBaseProdutosEditarIdLayoutRouteWithChildren
  PrivateDashboardBaseProdutosEditarIndexRoute: typeof PrivateDashboardBaseProdutosEditarIndexRoute
}

const PrivateDashboardBaseProdutosLayoutRouteChildren: PrivateDashboardBaseProdutosLayoutRouteChildren =
  {
    PrivateDashboardBaseProdutosIndexRoute:
      PrivateDashboardBaseProdutosIndexRoute,
    PrivateDashboardBaseProdutosEditarIdLayoutRoute:
      PrivateDashboardBaseProdutosEditarIdLayoutRouteWithChildren,
    PrivateDashboardBaseProdutosEditarIndexRoute:
      PrivateDashboardBaseProdutosEditarIndexRoute,
  }

const PrivateDashboardBaseProdutosLayoutRouteWithChildren =
  PrivateDashboardBaseProdutosLayoutRoute._addFileChildren(
    PrivateDashboardBaseProdutosLayoutRouteChildren,
  )

interface PrivateDashboardBaseUsuariosEditarIdLayoutRouteChildren {
  PrivateDashboardBaseUsuariosEditarIdModalRoute: typeof PrivateDashboardBaseUsuariosEditarIdModalRoute
  PrivateDashboardBaseUsuariosEditarIdIndexRoute: typeof PrivateDashboardBaseUsuariosEditarIdIndexRoute
}

const PrivateDashboardBaseUsuariosEditarIdLayoutRouteChildren: PrivateDashboardBaseUsuariosEditarIdLayoutRouteChildren =
  {
    PrivateDashboardBaseUsuariosEditarIdModalRoute:
      PrivateDashboardBaseUsuariosEditarIdModalRoute,
    PrivateDashboardBaseUsuariosEditarIdIndexRoute:
      PrivateDashboardBaseUsuariosEditarIdIndexRoute,
  }

const PrivateDashboardBaseUsuariosEditarIdLayoutRouteWithChildren =
  PrivateDashboardBaseUsuariosEditarIdLayoutRoute._addFileChildren(
    PrivateDashboardBaseUsuariosEditarIdLayoutRouteChildren,
  )

interface PrivateDashboardBaseUsuariosLayoutRouteChildren {
  PrivateDashboardBaseUsuariosIndexRoute: typeof PrivateDashboardBaseUsuariosIndexRoute
  PrivateDashboardBaseUsuariosEditarIdLayoutRoute: typeof PrivateDashboardBaseUsuariosEditarIdLayoutRouteWithChildren
  PrivateDashboardBaseUsuariosCadastrarModalRoute: typeof PrivateDashboardBaseUsuariosCadastrarModalRoute
  PrivateDashboardBaseUsuariosCadastrarIndexRoute: typeof PrivateDashboardBaseUsuariosCadastrarIndexRoute
  PrivateDashboardBaseUsuariosEditarIndexRoute: typeof PrivateDashboardBaseUsuariosEditarIndexRoute
}

const PrivateDashboardBaseUsuariosLayoutRouteChildren: PrivateDashboardBaseUsuariosLayoutRouteChildren =
  {
    PrivateDashboardBaseUsuariosIndexRoute:
      PrivateDashboardBaseUsuariosIndexRoute,
    PrivateDashboardBaseUsuariosEditarIdLayoutRoute:
      PrivateDashboardBaseUsuariosEditarIdLayoutRouteWithChildren,
    PrivateDashboardBaseUsuariosCadastrarModalRoute:
      PrivateDashboardBaseUsuariosCadastrarModalRoute,
    PrivateDashboardBaseUsuariosCadastrarIndexRoute:
      PrivateDashboardBaseUsuariosCadastrarIndexRoute,
    PrivateDashboardBaseUsuariosEditarIndexRoute:
      PrivateDashboardBaseUsuariosEditarIndexRoute,
  }

const PrivateDashboardBaseUsuariosLayoutRouteWithChildren =
  PrivateDashboardBaseUsuariosLayoutRoute._addFileChildren(
    PrivateDashboardBaseUsuariosLayoutRouteChildren,
  )

interface PrivateDashboardBasePedidosIdLayoutRouteChildren {
  PrivateDashboardBasePedidosIdModalRoute: typeof PrivateDashboardBasePedidosIdModalRoute
  PrivateDashboardBasePedidosIdIndexRoute: typeof PrivateDashboardBasePedidosIdIndexRoute
}

const PrivateDashboardBasePedidosIdLayoutRouteChildren: PrivateDashboardBasePedidosIdLayoutRouteChildren =
  {
    PrivateDashboardBasePedidosIdModalRoute:
      PrivateDashboardBasePedidosIdModalRoute,
    PrivateDashboardBasePedidosIdIndexRoute:
      PrivateDashboardBasePedidosIdIndexRoute,
  }

const PrivateDashboardBasePedidosIdLayoutRouteWithChildren =
  PrivateDashboardBasePedidosIdLayoutRoute._addFileChildren(
    PrivateDashboardBasePedidosIdLayoutRouteChildren,
  )

interface PrivateDashboardBasePedidosCadastrarLayoutRouteChildren {
  PrivateDashboardBasePedidosCadastrarModalRoute: typeof PrivateDashboardBasePedidosCadastrarModalRoute
  PrivateDashboardBasePedidosCadastrarIndexRoute: typeof PrivateDashboardBasePedidosCadastrarIndexRoute
}

const PrivateDashboardBasePedidosCadastrarLayoutRouteChildren: PrivateDashboardBasePedidosCadastrarLayoutRouteChildren =
  {
    PrivateDashboardBasePedidosCadastrarModalRoute:
      PrivateDashboardBasePedidosCadastrarModalRoute,
    PrivateDashboardBasePedidosCadastrarIndexRoute:
      PrivateDashboardBasePedidosCadastrarIndexRoute,
  }

const PrivateDashboardBasePedidosCadastrarLayoutRouteWithChildren =
  PrivateDashboardBasePedidosCadastrarLayoutRoute._addFileChildren(
    PrivateDashboardBasePedidosCadastrarLayoutRouteChildren,
  )

interface PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRouteChildren {
  PrivateDashboardBaseTransportadorasFormsCadastrarModalRoute: typeof PrivateDashboardBaseTransportadorasFormsCadastrarModalRoute
  PrivateDashboardBaseTransportadorasFormsCadastrarIndexRoute: typeof PrivateDashboardBaseTransportadorasFormsCadastrarIndexRoute
}

const PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRouteChildren: PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRouteChildren =
  {
    PrivateDashboardBaseTransportadorasFormsCadastrarModalRoute:
      PrivateDashboardBaseTransportadorasFormsCadastrarModalRoute,
    PrivateDashboardBaseTransportadorasFormsCadastrarIndexRoute:
      PrivateDashboardBaseTransportadorasFormsCadastrarIndexRoute,
  }

const PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRouteWithChildren =
  PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRoute._addFileChildren(
    PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRouteChildren,
  )

interface PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRouteChildren {
  PrivateDashboardBaseTransportadorasFormsEditarIdModalRoute: typeof PrivateDashboardBaseTransportadorasFormsEditarIdModalRoute
  PrivateDashboardBaseTransportadorasFormsEditarIdIndexRoute: typeof PrivateDashboardBaseTransportadorasFormsEditarIdIndexRoute
}

const PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRouteChildren: PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRouteChildren =
  {
    PrivateDashboardBaseTransportadorasFormsEditarIdModalRoute:
      PrivateDashboardBaseTransportadorasFormsEditarIdModalRoute,
    PrivateDashboardBaseTransportadorasFormsEditarIdIndexRoute:
      PrivateDashboardBaseTransportadorasFormsEditarIdIndexRoute,
  }

const PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRouteWithChildren =
  PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRoute._addFileChildren(
    PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRouteChildren,
  )

interface PrivateDashboardBaseTransportadorasFormsRouteChildren {
  PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRoute: typeof PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRouteWithChildren
  PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRoute: typeof PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRouteWithChildren
  PrivateDashboardBaseTransportadorasFormsEditarIndexRoute: typeof PrivateDashboardBaseTransportadorasFormsEditarIndexRoute
}

const PrivateDashboardBaseTransportadorasFormsRouteChildren: PrivateDashboardBaseTransportadorasFormsRouteChildren =
  {
    PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRoute:
      PrivateDashboardBaseTransportadorasFormsCadastrarLayoutRouteWithChildren,
    PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRoute:
      PrivateDashboardBaseTransportadorasFormsEditarIdLayoutRouteWithChildren,
    PrivateDashboardBaseTransportadorasFormsEditarIndexRoute:
      PrivateDashboardBaseTransportadorasFormsEditarIndexRoute,
  }

const PrivateDashboardBaseTransportadorasFormsRouteWithChildren =
  PrivateDashboardBaseTransportadorasFormsRoute._addFileChildren(
    PrivateDashboardBaseTransportadorasFormsRouteChildren,
  )

interface PrivateDashboardBaseClientesEditarIdLayoutRouteChildren {
  PrivateDashboardBaseClientesEditarIdModalRoute: typeof PrivateDashboardBaseClientesEditarIdModalRoute
  PrivateDashboardBaseClientesEditarIdIndexRoute: typeof PrivateDashboardBaseClientesEditarIdIndexRoute
}

const PrivateDashboardBaseClientesEditarIdLayoutRouteChildren: PrivateDashboardBaseClientesEditarIdLayoutRouteChildren =
  {
    PrivateDashboardBaseClientesEditarIdModalRoute:
      PrivateDashboardBaseClientesEditarIdModalRoute,
    PrivateDashboardBaseClientesEditarIdIndexRoute:
      PrivateDashboardBaseClientesEditarIdIndexRoute,
  }

const PrivateDashboardBaseClientesEditarIdLayoutRouteWithChildren =
  PrivateDashboardBaseClientesEditarIdLayoutRoute._addFileChildren(
    PrivateDashboardBaseClientesEditarIdLayoutRouteChildren,
  )

interface PrivateDashboardBaseEmpresasEditarIdLayoutRouteChildren {
  PrivateDashboardBaseEmpresasEditarIdModalRoute: typeof PrivateDashboardBaseEmpresasEditarIdModalRoute
  PrivateDashboardBaseEmpresasEditarIdIndexRoute: typeof PrivateDashboardBaseEmpresasEditarIdIndexRoute
}

const PrivateDashboardBaseEmpresasEditarIdLayoutRouteChildren: PrivateDashboardBaseEmpresasEditarIdLayoutRouteChildren =
  {
    PrivateDashboardBaseEmpresasEditarIdModalRoute:
      PrivateDashboardBaseEmpresasEditarIdModalRoute,
    PrivateDashboardBaseEmpresasEditarIdIndexRoute:
      PrivateDashboardBaseEmpresasEditarIdIndexRoute,
  }

const PrivateDashboardBaseEmpresasEditarIdLayoutRouteWithChildren =
  PrivateDashboardBaseEmpresasEditarIdLayoutRoute._addFileChildren(
    PrivateDashboardBaseEmpresasEditarIdLayoutRouteChildren,
  )

interface PrivateDashboardBasePedidosEditarIdLayoutRouteChildren {
  PrivateDashboardBasePedidosEditarIdModalRoute: typeof PrivateDashboardBasePedidosEditarIdModalRoute
  PrivateDashboardBasePedidosEditarIdIndexRoute: typeof PrivateDashboardBasePedidosEditarIdIndexRoute
}

const PrivateDashboardBasePedidosEditarIdLayoutRouteChildren: PrivateDashboardBasePedidosEditarIdLayoutRouteChildren =
  {
    PrivateDashboardBasePedidosEditarIdModalRoute:
      PrivateDashboardBasePedidosEditarIdModalRoute,
    PrivateDashboardBasePedidosEditarIdIndexRoute:
      PrivateDashboardBasePedidosEditarIdIndexRoute,
  }

const PrivateDashboardBasePedidosEditarIdLayoutRouteWithChildren =
  PrivateDashboardBasePedidosEditarIdLayoutRoute._addFileChildren(
    PrivateDashboardBasePedidosEditarIdLayoutRouteChildren,
  )

interface PrivateDashboardBaseRouteChildren {
  PrivateDashboardBaseConjuntosLayoutRoute: typeof PrivateDashboardBaseConjuntosLayoutRouteWithChildren
  PrivateDashboardBaseLogsLayoutRoute: typeof PrivateDashboardBaseLogsLayoutRouteWithChildren
  PrivateDashboardBaseMotoristasLayoutRoute: typeof PrivateDashboardBaseMotoristasLayoutRouteWithChildren
  PrivateDashboardBaseProdutosLayoutRoute: typeof PrivateDashboardBaseProdutosLayoutRouteWithChildren
  PrivateDashboardBaseUsuariosLayoutRoute: typeof PrivateDashboardBaseUsuariosLayoutRouteWithChildren
  PrivateDashboardBaseIndexRoute: typeof PrivateDashboardBaseIndexRoute
  PrivateDashboardBasePedidosIdLayoutRoute: typeof PrivateDashboardBasePedidosIdLayoutRouteWithChildren
  PrivateDashboardBasePedidosCadastrarLayoutRoute: typeof PrivateDashboardBasePedidosCadastrarLayoutRouteWithChildren
  PrivateDashboardBasePerfilModalRoute: typeof PrivateDashboardBasePerfilModalRoute
  PrivateDashboardBaseTransportadorasFormsRoute: typeof PrivateDashboardBaseTransportadorasFormsRouteWithChildren
  PrivateDashboardBaseClientesIndexRoute: typeof PrivateDashboardBaseClientesIndexRoute
  PrivateDashboardBaseEmpresasIndexRoute: typeof PrivateDashboardBaseEmpresasIndexRoute
  PrivateDashboardBaseFilaIndexRoute: typeof PrivateDashboardBaseFilaIndexRoute
  PrivateDashboardBasePedidosIndexRoute: typeof PrivateDashboardBasePedidosIndexRoute
  PrivateDashboardBasePerfilIndexRoute: typeof PrivateDashboardBasePerfilIndexRoute
  PrivateDashboardBaseResgateIndexRoute: typeof PrivateDashboardBaseResgateIndexRoute
  PrivateDashboardBaseTransportadorasIndexRoute: typeof PrivateDashboardBaseTransportadorasIndexRoute
  PrivateDashboardBaseClientesEditarIdLayoutRoute: typeof PrivateDashboardBaseClientesEditarIdLayoutRouteWithChildren
  PrivateDashboardBaseEmpresasEditarIdLayoutRoute: typeof PrivateDashboardBaseEmpresasEditarIdLayoutRouteWithChildren
  PrivateDashboardBasePedidosEditarIdLayoutRoute: typeof PrivateDashboardBasePedidosEditarIdLayoutRouteWithChildren
  PrivateDashboardBaseClientesCadastrarModalRoute: typeof PrivateDashboardBaseClientesCadastrarModalRoute
  PrivateDashboardBaseEmpresasCadastrarModalRoute: typeof PrivateDashboardBaseEmpresasCadastrarModalRoute
  PrivateDashboardBaseClientesCadastrarIndexRoute: typeof PrivateDashboardBaseClientesCadastrarIndexRoute
  PrivateDashboardBaseClientesEditarIndexRoute: typeof PrivateDashboardBaseClientesEditarIndexRoute
  PrivateDashboardBaseEmpresasCadastrarIndexRoute: typeof PrivateDashboardBaseEmpresasCadastrarIndexRoute
  PrivateDashboardBaseEmpresasEditarIndexRoute: typeof PrivateDashboardBaseEmpresasEditarIndexRoute
  PrivateDashboardBasePedidosEditarIndexRoute: typeof PrivateDashboardBasePedidosEditarIndexRoute
}

const PrivateDashboardBaseRouteChildren: PrivateDashboardBaseRouteChildren = {
  PrivateDashboardBaseConjuntosLayoutRoute:
    PrivateDashboardBaseConjuntosLayoutRouteWithChildren,
  PrivateDashboardBaseLogsLayoutRoute:
    PrivateDashboardBaseLogsLayoutRouteWithChildren,
  PrivateDashboardBaseMotoristasLayoutRoute:
    PrivateDashboardBaseMotoristasLayoutRouteWithChildren,
  PrivateDashboardBaseProdutosLayoutRoute:
    PrivateDashboardBaseProdutosLayoutRouteWithChildren,
  PrivateDashboardBaseUsuariosLayoutRoute:
    PrivateDashboardBaseUsuariosLayoutRouteWithChildren,
  PrivateDashboardBaseIndexRoute: PrivateDashboardBaseIndexRoute,
  PrivateDashboardBasePedidosIdLayoutRoute:
    PrivateDashboardBasePedidosIdLayoutRouteWithChildren,
  PrivateDashboardBasePedidosCadastrarLayoutRoute:
    PrivateDashboardBasePedidosCadastrarLayoutRouteWithChildren,
  PrivateDashboardBasePerfilModalRoute: PrivateDashboardBasePerfilModalRoute,
  PrivateDashboardBaseTransportadorasFormsRoute:
    PrivateDashboardBaseTransportadorasFormsRouteWithChildren,
  PrivateDashboardBaseClientesIndexRoute:
    PrivateDashboardBaseClientesIndexRoute,
  PrivateDashboardBaseEmpresasIndexRoute:
    PrivateDashboardBaseEmpresasIndexRoute,
  PrivateDashboardBaseFilaIndexRoute: PrivateDashboardBaseFilaIndexRoute,
  PrivateDashboardBasePedidosIndexRoute: PrivateDashboardBasePedidosIndexRoute,
  PrivateDashboardBasePerfilIndexRoute: PrivateDashboardBasePerfilIndexRoute,
  PrivateDashboardBaseResgateIndexRoute: PrivateDashboardBaseResgateIndexRoute,
  PrivateDashboardBaseTransportadorasIndexRoute:
    PrivateDashboardBaseTransportadorasIndexRoute,
  PrivateDashboardBaseClientesEditarIdLayoutRoute:
    PrivateDashboardBaseClientesEditarIdLayoutRouteWithChildren,
  PrivateDashboardBaseEmpresasEditarIdLayoutRoute:
    PrivateDashboardBaseEmpresasEditarIdLayoutRouteWithChildren,
  PrivateDashboardBasePedidosEditarIdLayoutRoute:
    PrivateDashboardBasePedidosEditarIdLayoutRouteWithChildren,
  PrivateDashboardBaseClientesCadastrarModalRoute:
    PrivateDashboardBaseClientesCadastrarModalRoute,
  PrivateDashboardBaseEmpresasCadastrarModalRoute:
    PrivateDashboardBaseEmpresasCadastrarModalRoute,
  PrivateDashboardBaseClientesCadastrarIndexRoute:
    PrivateDashboardBaseClientesCadastrarIndexRoute,
  PrivateDashboardBaseClientesEditarIndexRoute:
    PrivateDashboardBaseClientesEditarIndexRoute,
  PrivateDashboardBaseEmpresasCadastrarIndexRoute:
    PrivateDashboardBaseEmpresasCadastrarIndexRoute,
  PrivateDashboardBaseEmpresasEditarIndexRoute:
    PrivateDashboardBaseEmpresasEditarIndexRoute,
  PrivateDashboardBasePedidosEditarIndexRoute:
    PrivateDashboardBasePedidosEditarIndexRoute,
}

const PrivateDashboardBaseRouteWithChildren =
  PrivateDashboardBaseRoute._addFileChildren(PrivateDashboardBaseRouteChildren)

interface PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRouteChildren {
  PrivateDashboardSettingsConfiguracoesPopupsIdModalRoute: typeof PrivateDashboardSettingsConfiguracoesPopupsIdModalRoute
  PrivateDashboardSettingsConfiguracoesPopupsIdIndexRoute: typeof PrivateDashboardSettingsConfiguracoesPopupsIdIndexRoute
}

const PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRouteChildren: PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRouteChildren =
  {
    PrivateDashboardSettingsConfiguracoesPopupsIdModalRoute:
      PrivateDashboardSettingsConfiguracoesPopupsIdModalRoute,
    PrivateDashboardSettingsConfiguracoesPopupsIdIndexRoute:
      PrivateDashboardSettingsConfiguracoesPopupsIdIndexRoute,
  }

const PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRouteWithChildren =
  PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRoute._addFileChildren(
    PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRouteChildren,
  )

interface PrivateDashboardSettingsConfiguracoesTermosIdLayoutRouteChildren {
  PrivateDashboardSettingsConfiguracoesTermosIdModalRoute: typeof PrivateDashboardSettingsConfiguracoesTermosIdModalRoute
  PrivateDashboardSettingsConfiguracoesTermosIdIndexRoute: typeof PrivateDashboardSettingsConfiguracoesTermosIdIndexRoute
}

const PrivateDashboardSettingsConfiguracoesTermosIdLayoutRouteChildren: PrivateDashboardSettingsConfiguracoesTermosIdLayoutRouteChildren =
  {
    PrivateDashboardSettingsConfiguracoesTermosIdModalRoute:
      PrivateDashboardSettingsConfiguracoesTermosIdModalRoute,
    PrivateDashboardSettingsConfiguracoesTermosIdIndexRoute:
      PrivateDashboardSettingsConfiguracoesTermosIdIndexRoute,
  }

const PrivateDashboardSettingsConfiguracoesTermosIdLayoutRouteWithChildren =
  PrivateDashboardSettingsConfiguracoesTermosIdLayoutRoute._addFileChildren(
    PrivateDashboardSettingsConfiguracoesTermosIdLayoutRouteChildren,
  )

interface PrivateDashboardSettingsConfiguracoesLayoutRouteChildren {
  PrivateDashboardSettingsConfiguracoesAvisosRoute: typeof PrivateDashboardSettingsConfiguracoesAvisosRoute
  PrivateDashboardSettingsConfiguracoesBloqueiosRoute: typeof PrivateDashboardSettingsConfiguracoesBloqueiosRoute
  PrivateDashboardSettingsConfiguracoesInformacoesRoute: typeof PrivateDashboardSettingsConfiguracoesInformacoesRoute
  PrivateDashboardSettingsConfiguracoesIndexRoute: typeof PrivateDashboardSettingsConfiguracoesIndexRoute
  PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRoute: typeof PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRouteWithChildren
  PrivateDashboardSettingsConfiguracoesTermosIdLayoutRoute: typeof PrivateDashboardSettingsConfiguracoesTermosIdLayoutRouteWithChildren
  PrivateDashboardSettingsConfiguracoesPopupsIndexRoute: typeof PrivateDashboardSettingsConfiguracoesPopupsIndexRoute
  PrivateDashboardSettingsConfiguracoesTermosIndexRoute: typeof PrivateDashboardSettingsConfiguracoesTermosIndexRoute
}

const PrivateDashboardSettingsConfiguracoesLayoutRouteChildren: PrivateDashboardSettingsConfiguracoesLayoutRouteChildren =
  {
    PrivateDashboardSettingsConfiguracoesAvisosRoute:
      PrivateDashboardSettingsConfiguracoesAvisosRoute,
    PrivateDashboardSettingsConfiguracoesBloqueiosRoute:
      PrivateDashboardSettingsConfiguracoesBloqueiosRoute,
    PrivateDashboardSettingsConfiguracoesInformacoesRoute:
      PrivateDashboardSettingsConfiguracoesInformacoesRoute,
    PrivateDashboardSettingsConfiguracoesIndexRoute:
      PrivateDashboardSettingsConfiguracoesIndexRoute,
    PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRoute:
      PrivateDashboardSettingsConfiguracoesPopupsIdLayoutRouteWithChildren,
    PrivateDashboardSettingsConfiguracoesTermosIdLayoutRoute:
      PrivateDashboardSettingsConfiguracoesTermosIdLayoutRouteWithChildren,
    PrivateDashboardSettingsConfiguracoesPopupsIndexRoute:
      PrivateDashboardSettingsConfiguracoesPopupsIndexRoute,
    PrivateDashboardSettingsConfiguracoesTermosIndexRoute:
      PrivateDashboardSettingsConfiguracoesTermosIndexRoute,
  }

const PrivateDashboardSettingsConfiguracoesLayoutRouteWithChildren =
  PrivateDashboardSettingsConfiguracoesLayoutRoute._addFileChildren(
    PrivateDashboardSettingsConfiguracoesLayoutRouteChildren,
  )

interface PrivateDashboardSettingsRouteChildren {
  PrivateDashboardSettingsConfiguracoesLayoutRoute: typeof PrivateDashboardSettingsConfiguracoesLayoutRouteWithChildren
}

const PrivateDashboardSettingsRouteChildren: PrivateDashboardSettingsRouteChildren =
  {
    PrivateDashboardSettingsConfiguracoesLayoutRoute:
      PrivateDashboardSettingsConfiguracoesLayoutRouteWithChildren,
  }

const PrivateDashboardSettingsRouteWithChildren =
  PrivateDashboardSettingsRoute._addFileChildren(
    PrivateDashboardSettingsRouteChildren,
  )

interface PrivateDashboardTrucksCaminhoesEditarIdLayoutRouteChildren {
  PrivateDashboardTrucksCaminhoesEditarIdModalRoute: typeof PrivateDashboardTrucksCaminhoesEditarIdModalRoute
  PrivateDashboardTrucksCaminhoesEditarIdIndexRoute: typeof PrivateDashboardTrucksCaminhoesEditarIdIndexRoute
}

const PrivateDashboardTrucksCaminhoesEditarIdLayoutRouteChildren: PrivateDashboardTrucksCaminhoesEditarIdLayoutRouteChildren =
  {
    PrivateDashboardTrucksCaminhoesEditarIdModalRoute:
      PrivateDashboardTrucksCaminhoesEditarIdModalRoute,
    PrivateDashboardTrucksCaminhoesEditarIdIndexRoute:
      PrivateDashboardTrucksCaminhoesEditarIdIndexRoute,
  }

const PrivateDashboardTrucksCaminhoesEditarIdLayoutRouteWithChildren =
  PrivateDashboardTrucksCaminhoesEditarIdLayoutRoute._addFileChildren(
    PrivateDashboardTrucksCaminhoesEditarIdLayoutRouteChildren,
  )

interface PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRouteChildren {
  PrivateDashboardTrucksCaminhoesCarregamentosEditarIdModalRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdModalRoute
  PrivateDashboardTrucksCaminhoesCarregamentosEditarIdIndexRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdIndexRoute
}

const PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRouteChildren: PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRouteChildren =
  {
    PrivateDashboardTrucksCaminhoesCarregamentosEditarIdModalRoute:
      PrivateDashboardTrucksCaminhoesCarregamentosEditarIdModalRoute,
    PrivateDashboardTrucksCaminhoesCarregamentosEditarIdIndexRoute:
      PrivateDashboardTrucksCaminhoesCarregamentosEditarIdIndexRoute,
  }

const PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRouteWithChildren =
  PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRoute._addFileChildren(
    PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRouteChildren,
  )

interface PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRouteChildren {
  PrivateDashboardTrucksCaminhoesImplementosEditarIdModalRoute: typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdModalRoute
  PrivateDashboardTrucksCaminhoesImplementosEditarIdIndexRoute: typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdIndexRoute
}

const PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRouteChildren: PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRouteChildren =
  {
    PrivateDashboardTrucksCaminhoesImplementosEditarIdModalRoute:
      PrivateDashboardTrucksCaminhoesImplementosEditarIdModalRoute,
    PrivateDashboardTrucksCaminhoesImplementosEditarIdIndexRoute:
      PrivateDashboardTrucksCaminhoesImplementosEditarIdIndexRoute,
  }

const PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRouteWithChildren =
  PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRoute._addFileChildren(
    PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRouteChildren,
  )

interface PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRouteChildren {
  PrivateDashboardTrucksCaminhoesMarcasEditarIdModalRoute: typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdModalRoute
  PrivateDashboardTrucksCaminhoesMarcasEditarIdIndexRoute: typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdIndexRoute
}

const PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRouteChildren: PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRouteChildren =
  {
    PrivateDashboardTrucksCaminhoesMarcasEditarIdModalRoute:
      PrivateDashboardTrucksCaminhoesMarcasEditarIdModalRoute,
    PrivateDashboardTrucksCaminhoesMarcasEditarIdIndexRoute:
      PrivateDashboardTrucksCaminhoesMarcasEditarIdIndexRoute,
  }

const PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRouteWithChildren =
  PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRoute._addFileChildren(
    PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRouteChildren,
  )

interface PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRouteChildren {
  PrivateDashboardTrucksCaminhoesModelosEditarIdModalRoute: typeof PrivateDashboardTrucksCaminhoesModelosEditarIdModalRoute
  PrivateDashboardTrucksCaminhoesModelosEditarIdIndexRoute: typeof PrivateDashboardTrucksCaminhoesModelosEditarIdIndexRoute
}

const PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRouteChildren: PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRouteChildren =
  {
    PrivateDashboardTrucksCaminhoesModelosEditarIdModalRoute:
      PrivateDashboardTrucksCaminhoesModelosEditarIdModalRoute,
    PrivateDashboardTrucksCaminhoesModelosEditarIdIndexRoute:
      PrivateDashboardTrucksCaminhoesModelosEditarIdIndexRoute,
  }

const PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRouteWithChildren =
  PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRoute._addFileChildren(
    PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRouteChildren,
  )

interface PrivateDashboardTrucksCaminhoesLayoutRouteChildren {
  PrivateDashboardTrucksCaminhoesIndexRoute: typeof PrivateDashboardTrucksCaminhoesIndexRoute
  PrivateDashboardTrucksCaminhoesEditarIdLayoutRoute: typeof PrivateDashboardTrucksCaminhoesEditarIdLayoutRouteWithChildren
  PrivateDashboardTrucksCaminhoesCadastrarModalRoute: typeof PrivateDashboardTrucksCaminhoesCadastrarModalRoute
  PrivateDashboardTrucksCaminhoesCadastrarIndexRoute: typeof PrivateDashboardTrucksCaminhoesCadastrarIndexRoute
  PrivateDashboardTrucksCaminhoesCarregamentosIndexRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosIndexRoute
  PrivateDashboardTrucksCaminhoesEditarIndexRoute: typeof PrivateDashboardTrucksCaminhoesEditarIndexRoute
  PrivateDashboardTrucksCaminhoesImplementosIndexRoute: typeof PrivateDashboardTrucksCaminhoesImplementosIndexRoute
  PrivateDashboardTrucksCaminhoesMarcasIndexRoute: typeof PrivateDashboardTrucksCaminhoesMarcasIndexRoute
  PrivateDashboardTrucksCaminhoesModelosIndexRoute: typeof PrivateDashboardTrucksCaminhoesModelosIndexRoute
  PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRouteWithChildren
  PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRoute: typeof PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRouteWithChildren
  PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRoute: typeof PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRouteWithChildren
  PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRoute: typeof PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRouteWithChildren
  PrivateDashboardTrucksCaminhoesCarregamentosCadastrarModalRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosCadastrarModalRoute
  PrivateDashboardTrucksCaminhoesImplementosCadastrarModalRoute: typeof PrivateDashboardTrucksCaminhoesImplementosCadastrarModalRoute
  PrivateDashboardTrucksCaminhoesMarcasCadastrarModalRoute: typeof PrivateDashboardTrucksCaminhoesMarcasCadastrarModalRoute
  PrivateDashboardTrucksCaminhoesModelosCadastrarModalRoute: typeof PrivateDashboardTrucksCaminhoesModelosCadastrarModalRoute
  PrivateDashboardTrucksCaminhoesCarregamentosCadastrarIndexRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosCadastrarIndexRoute
  PrivateDashboardTrucksCaminhoesCarregamentosEditarIndexRoute: typeof PrivateDashboardTrucksCaminhoesCarregamentosEditarIndexRoute
  PrivateDashboardTrucksCaminhoesImplementosCadastrarIndexRoute: typeof PrivateDashboardTrucksCaminhoesImplementosCadastrarIndexRoute
  PrivateDashboardTrucksCaminhoesImplementosEditarIndexRoute: typeof PrivateDashboardTrucksCaminhoesImplementosEditarIndexRoute
  PrivateDashboardTrucksCaminhoesMarcasCadastrarIndexRoute: typeof PrivateDashboardTrucksCaminhoesMarcasCadastrarIndexRoute
  PrivateDashboardTrucksCaminhoesMarcasEditarIndexRoute: typeof PrivateDashboardTrucksCaminhoesMarcasEditarIndexRoute
  PrivateDashboardTrucksCaminhoesModelosCadastrarIndexRoute: typeof PrivateDashboardTrucksCaminhoesModelosCadastrarIndexRoute
  PrivateDashboardTrucksCaminhoesModelosEditarIndexRoute: typeof PrivateDashboardTrucksCaminhoesModelosEditarIndexRoute
}

const PrivateDashboardTrucksCaminhoesLayoutRouteChildren: PrivateDashboardTrucksCaminhoesLayoutRouteChildren =
  {
    PrivateDashboardTrucksCaminhoesIndexRoute:
      PrivateDashboardTrucksCaminhoesIndexRoute,
    PrivateDashboardTrucksCaminhoesEditarIdLayoutRoute:
      PrivateDashboardTrucksCaminhoesEditarIdLayoutRouteWithChildren,
    PrivateDashboardTrucksCaminhoesCadastrarModalRoute:
      PrivateDashboardTrucksCaminhoesCadastrarModalRoute,
    PrivateDashboardTrucksCaminhoesCadastrarIndexRoute:
      PrivateDashboardTrucksCaminhoesCadastrarIndexRoute,
    PrivateDashboardTrucksCaminhoesCarregamentosIndexRoute:
      PrivateDashboardTrucksCaminhoesCarregamentosIndexRoute,
    PrivateDashboardTrucksCaminhoesEditarIndexRoute:
      PrivateDashboardTrucksCaminhoesEditarIndexRoute,
    PrivateDashboardTrucksCaminhoesImplementosIndexRoute:
      PrivateDashboardTrucksCaminhoesImplementosIndexRoute,
    PrivateDashboardTrucksCaminhoesMarcasIndexRoute:
      PrivateDashboardTrucksCaminhoesMarcasIndexRoute,
    PrivateDashboardTrucksCaminhoesModelosIndexRoute:
      PrivateDashboardTrucksCaminhoesModelosIndexRoute,
    PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRoute:
      PrivateDashboardTrucksCaminhoesCarregamentosEditarIdLayoutRouteWithChildren,
    PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRoute:
      PrivateDashboardTrucksCaminhoesImplementosEditarIdLayoutRouteWithChildren,
    PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRoute:
      PrivateDashboardTrucksCaminhoesMarcasEditarIdLayoutRouteWithChildren,
    PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRoute:
      PrivateDashboardTrucksCaminhoesModelosEditarIdLayoutRouteWithChildren,
    PrivateDashboardTrucksCaminhoesCarregamentosCadastrarModalRoute:
      PrivateDashboardTrucksCaminhoesCarregamentosCadastrarModalRoute,
    PrivateDashboardTrucksCaminhoesImplementosCadastrarModalRoute:
      PrivateDashboardTrucksCaminhoesImplementosCadastrarModalRoute,
    PrivateDashboardTrucksCaminhoesMarcasCadastrarModalRoute:
      PrivateDashboardTrucksCaminhoesMarcasCadastrarModalRoute,
    PrivateDashboardTrucksCaminhoesModelosCadastrarModalRoute:
      PrivateDashboardTrucksCaminhoesModelosCadastrarModalRoute,
    PrivateDashboardTrucksCaminhoesCarregamentosCadastrarIndexRoute:
      PrivateDashboardTrucksCaminhoesCarregamentosCadastrarIndexRoute,
    PrivateDashboardTrucksCaminhoesCarregamentosEditarIndexRoute:
      PrivateDashboardTrucksCaminhoesCarregamentosEditarIndexRoute,
    PrivateDashboardTrucksCaminhoesImplementosCadastrarIndexRoute:
      PrivateDashboardTrucksCaminhoesImplementosCadastrarIndexRoute,
    PrivateDashboardTrucksCaminhoesImplementosEditarIndexRoute:
      PrivateDashboardTrucksCaminhoesImplementosEditarIndexRoute,
    PrivateDashboardTrucksCaminhoesMarcasCadastrarIndexRoute:
      PrivateDashboardTrucksCaminhoesMarcasCadastrarIndexRoute,
    PrivateDashboardTrucksCaminhoesMarcasEditarIndexRoute:
      PrivateDashboardTrucksCaminhoesMarcasEditarIndexRoute,
    PrivateDashboardTrucksCaminhoesModelosCadastrarIndexRoute:
      PrivateDashboardTrucksCaminhoesModelosCadastrarIndexRoute,
    PrivateDashboardTrucksCaminhoesModelosEditarIndexRoute:
      PrivateDashboardTrucksCaminhoesModelosEditarIndexRoute,
  }

const PrivateDashboardTrucksCaminhoesLayoutRouteWithChildren =
  PrivateDashboardTrucksCaminhoesLayoutRoute._addFileChildren(
    PrivateDashboardTrucksCaminhoesLayoutRouteChildren,
  )

interface PrivateDashboardTrucksRouteChildren {
  PrivateDashboardTrucksCaminhoesLayoutRoute: typeof PrivateDashboardTrucksCaminhoesLayoutRouteWithChildren
}

const PrivateDashboardTrucksRouteChildren: PrivateDashboardTrucksRouteChildren =
  {
    PrivateDashboardTrucksCaminhoesLayoutRoute:
      PrivateDashboardTrucksCaminhoesLayoutRouteWithChildren,
  }

const PrivateDashboardTrucksRouteWithChildren =
  PrivateDashboardTrucksRoute._addFileChildren(
    PrivateDashboardTrucksRouteChildren,
  )

interface PrivateDashboardLayoutRouteChildren {
  PrivateDashboardBaseRoute: typeof PrivateDashboardBaseRouteWithChildren
  PrivateDashboardSettingsRoute: typeof PrivateDashboardSettingsRouteWithChildren
  PrivateDashboardTrucksRoute: typeof PrivateDashboardTrucksRouteWithChildren
}

const PrivateDashboardLayoutRouteChildren: PrivateDashboardLayoutRouteChildren =
  {
    PrivateDashboardBaseRoute: PrivateDashboardBaseRouteWithChildren,
    PrivateDashboardSettingsRoute: PrivateDashboardSettingsRouteWithChildren,
    PrivateDashboardTrucksRoute: PrivateDashboardTrucksRouteWithChildren,
  }

const PrivateDashboardLayoutRouteWithChildren =
  PrivateDashboardLayoutRoute._addFileChildren(
    PrivateDashboardLayoutRouteChildren,
  )

interface PrivateRouteChildren {
  PrivateDashboardLayoutRoute: typeof PrivateDashboardLayoutRouteWithChildren
  PrivateAprovarTermoTransportadoraEmpresaCompanyIdUserIdRoute: typeof PrivateAprovarTermoTransportadoraEmpresaCompanyIdUserIdRoute
}

const PrivateRouteChildren: PrivateRouteChildren = {
  PrivateDashboardLayoutRoute: PrivateDashboardLayoutRouteWithChildren,
  PrivateAprovarTermoTransportadoraEmpresaCompanyIdUserIdRoute:
    PrivateAprovarTermoTransportadoraEmpresaCompanyIdUserIdRoute,
}

const PrivateRouteWithChildren =
  PrivateRoute._addFileChildren(PrivateRouteChildren)

interface PublicRouteChildren {
  Public403Route: typeof Public403Route
  Public503Route: typeof Public503Route
  PublicIndexRoute: typeof PublicIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  Public403Route: Public403Route,
  Public503Route: Public503Route,
  PublicIndexRoute: PublicIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  PrivateRoute: PrivateRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
